export const en = {
  'common.loading': 'Loading…',
  'common.save': 'Save',
  'common.saving': 'Saving…',
  'common.cancel': 'Cancel',
  'common.delete': 'Delete',
  'common.search': 'Search',
  'common.clearSearch': 'Clear search',
  'common.sortBy': 'Sort by',
  'common.name': 'Name',
  'common.role': 'Role',
  'common.groups': 'Groups',
  'common.tickets': 'Tickets',
  'common.lastSeen': 'Last seen',
  'common.actions': 'Actions',
  'common.never': 'Never',
  'common.justNow': 'Just now',
  'common.minutesAgo': '{count}m ago',
  'common.hoursAgo': '{count}h ago',
  'common.daysAgo': '{count}d ago',
  'common.accessDenied': 'Access Denied',
  'common.noPagePermission': 'You do not have permission to access this page.',
  'common.roleNoPermission': 'Your role does not have permission to access this page.',
  'common.requestFailed': 'Request failed. Please try again.',
  'common.unexpectedError': 'An unexpected error occurred',
  'common.backToLogin': 'Back to login',
  'common.markAsRead': 'Mark as read',
  'common.user': 'User',

  'shell.skipToMain': 'Skip to main content',
  'shell.homeLabel': 'Suzuki Support Desk home',
  'shell.supportDesk': 'Support Desk',
  'shell.searchPlaceholder': 'Search tickets, contacts, articles…',
  'shell.newTicket': 'New ticket',
  'shell.userMenu': 'User menu',
  'shell.notifications': 'Notifications',
  'shell.unread': '{count} unread',
  'shell.notificationPreferences': 'Notification preferences',
  'shell.settings': 'Settings',
  'shell.signOut': 'Sign out',
  'shell.expandNavigation': 'Expand navigation',
  'shell.collapseNavigation': 'Collapse navigation',
  'shell.adminNavigation': 'Admin navigation',
  'shell.caughtUp': "You're all caught up",
  'shell.notificationDescription': 'New assignments, replies, and SLA alerts will show up here.',
  'shell.viewAllNotifications': 'View all notifications',

  'nav.dashboard': 'Dashboard',
  'nav.tickets': 'Tickets',
  'nav.contacts': 'Contacts',
  'nav.companies': 'Companies',
  'nav.reports': 'Reports',
  'nav.settings': 'Settings',
  'nav.agents': 'Agents',
  'nav.groups': 'Groups',
  'nav.roles': 'Roles',
  'nav.tags': 'Tags',
  'nav.ticketFields': 'Ticket Fields',
  'nav.ticketForms': 'Ticket Forms',
  'nav.businessHours': 'Business Hours',
  'nav.slaPolicies': 'SLA Policies',
  'nav.automations': 'Automations',
  'nav.email': 'Email',
  'nav.jira': 'Jira integration',
  'nav.notificationTemplates': 'Notification Templates',
  'nav.apiKeys': 'API Keys',
  'nav.cannedResponses': 'Canned Responses',
  'nav.knowledgeBase': 'Knowledge Base',

  'auth.twoFactor': 'Two-Factor Authentication',
  'auth.enterAuthenticatorCode': 'Enter the 6-digit code from your authenticator app',
  'auth.verificationCode': 'Verification code',
  'auth.verifying': 'Verifying…',
  'auth.verify': 'Verify',
  'auth.setupAuthenticator': 'Set Up Authenticator',
  'auth.scanAuthenticator': 'Scan this code with your authenticator app (Google Authenticator, Authy, etc.)',
  'auth.authenticatorSetupQr': 'Authenticator setup QR code',
  'auth.verificationCodeFromAuthenticator': 'Verification code from authenticator',
  'auth.verifyAndComplete': 'Verify and Complete Setup',
  'auth.loadingSetup': 'Loading setup…',
  'auth.setNewPassword': 'Set New Password',
  'auth.temporaryPasswordExpired': 'Your temporary password has expired. Please set a new password.',
  'auth.newPassword': 'New password',
  'auth.confirmPassword': 'Confirm password',
  'auth.settingPassword': 'Setting password…',
  'auth.setPassword': 'Set Password',
  'auth.passwordRequirements': '8+ characters, uppercase, lowercase, number, and symbol required',
  'auth.signInTitle': 'SDPL Support Desk',
  'auth.signInSubtitle': 'Sign in to your account',
  'auth.emailAddress': 'Email address',
  'auth.password': 'Password',
  'auth.signingIn': 'Signing in…',
  'auth.signIn': 'Sign in',
  'auth.forgotPassword': 'Forgot your password?',
  'auth.tooManyAttempts': 'Too many login attempts. Please try again later.',
  'auth.invalidCredentials': 'Invalid email or password',
  'auth.passwordsDoNotMatch': 'Passwords do not match',
  'auth.passwordMinimum': 'Password must be at least {count} characters',
  'auth.resetTitle': 'Reset your password',
  'auth.resetSubtitle': "Enter your email and we'll send you a reset link",
  'auth.checkEmail': 'Check your email for a reset link',
  'auth.checkCode': 'Check your email for a verification code, then continue below.',
  'auth.continueToReset': 'Continue to reset your password',
  'auth.sendResetLink': 'Send reset link',
  'auth.sending': 'Sending…',
  'auth.resetSuccess': 'Your password has been reset successfully.',
  'auth.goToLogin': 'Go to login',
  'auth.missingResetToken': 'Missing reset token. Please use the link from your email.',
  'auth.enterCodeFromEmail': 'Enter the verification code sent to your email',
  'auth.codeFromEmail': 'Enter code from email',
  'auth.emailRequired': 'Email is required',
  'auth.codeRequired': 'Verification code is required',
  'auth.missingToken': 'Missing reset token',
  'auth.failedReset': 'Failed to reset password.',
  'auth.resetting': 'Resetting…',
  'auth.resetPassword': 'Reset password',
  'auth.looksGood': 'Looks good',
  'auth.needCharacters': 'Need at least {count} characters',
  'auth.passwordFormat': '{count}+ chars, uppercase, lowercase, number, and symbol required',

  'agents.title': 'Agents',
  'agents.description': 'People who work tickets. Assign a role to control what they can do, and groups to control what they see.',
  'agents.new': 'New Agent',
  'agents.supportAgents': 'Support Agents',
  'agents.collaborators': 'Collaborators',
  'agents.deactivated': 'Deactivated',
  'agents.searchPlaceholder': 'Search by name or email',
  'agents.searchAria': 'Search agents',
  'agents.countOne': '{count} agent',
  'agents.countMany': '{count} agents',
  'agents.ticketOne': '{count} ticket',
  'agents.ticketMany': '{count} tickets',
  'agents.noGroups': 'No groups',
  'agents.lifecycle': 'Agent lifecycle',
  'agents.noSearchResults': 'No agents match this search',
  'agents.noAgentsView': 'No agents in this view',
  'agents.tryDifferent': 'Try a different name or email address.',
  'agents.useNewAgent': 'Use New Agent to add someone, or switch tabs to see other agents.',
  'agents.agent': 'Agent',
  'agents.noRole': 'No role',
  'agents.openTicketsTitle': 'Open tickets currently assigned to this agent',
  'agents.edit': 'Edit',
  'agents.moreActions': 'More actions for {name}',
  'agents.confirmDeleteTitle': 'Delete {name}?',
  'agents.confirmDeleteDescription': 'This cannot be undone. Agents linked to tickets cannot be deleted; deactivate them instead.',
  'agents.confirmDeleteLabel': 'Delete agent',
  'agents.deactivate': 'Deactivate',
  'agents.reactivate': 'Reactivate',
  'agents.agentsVsCollaborators': 'Agents vs Collaborators',
  'agents.agentsVsCollaboratorsBody': 'Support Agents work tickets day to day. Collaborators have a collaborator role and are typically subject-matter experts brought in on individual tickets without full agent access.',
  'agents.deactivateVsDelete': 'Deactivate vs Delete',
  'agents.deactivateVsDeleteBody': 'Deactivating keeps history and ticket ownership intact but blocks sign-in. Delete is permanent and only works once the agent has no linked tickets.',
  'agents.newTitle': 'New Agent',
  'agents.editTitle': 'Edit Agent',
  'agents.saved': 'Agent saved.',
  'agents.firstName': 'First name',
  'agents.lastName': 'Last name',
  'agents.email': 'Email',
  'agents.temporaryPassword': 'Temporary password',
  'agents.passwordHelp': 'At least 12 characters, with an uppercase letter, a lowercase letter, a number and a symbol. The agent will be asked to change it at first sign-in.',
  'agents.phone': 'Phone',
  'agents.timezone': 'Timezone',
  'agents.selectTimezone': 'Select timezone',
  'agents.timezoneHelp': 'Every date and time this agent sees is rendered in this timezone.',
  'agents.language': 'Language',
  'agents.selectLanguage': 'Select language',
  'agents.languageHelp': 'Translates the agent-facing interface. Ticket replies and customer content are not translated.',
  'agents.emailSignature': 'Email signature',
  'agents.signaturePlaceholder': 'Appended to outgoing replies',
  'agents.roleRequired': 'Role',
  'agents.selectRole': 'Select role',
  'agents.roleHelp': 'Determines what this agent can do.',
  'agents.manageRoles': 'Manage roles',
  'agents.status': 'Status',
  'agents.activeHelp': 'Active — unchecking blocks sign-in without deleting the agent',
  'agents.groupsTitle': 'Groups',
  'agents.assignGroups': 'Assign groups',
  'agents.selectGroups': 'Select groups',
  'agents.assignGroupsHelp': 'Group membership controls which tickets this agent can see.',
  'agents.ticketVisibility': 'Ticket visibility',
  'agents.ticketVisibilityHelp': 'Choose a narrower per-agent boundary or inherit the role default. Role permissions still control what the agent can do.',
  'agents.scopeRoleDefault': 'Use role default',
  'agents.scopeRoleDefaultHelp': 'Inherit the default visibility configured for this role.',
  'agents.scopeAll': 'All tickets',
  'agents.scopeAllHelp': 'See every non-deleted ticket in this account.',
  'agents.scopeGroup': 'Tickets in a group',
  'agents.scopeGroupHelp': 'See tickets assigned to groups this agent belongs to.',
  'agents.scopeAssigned': 'Assigned tickets',
  'agents.scopeAssignedHelp': 'See tickets assigned directly to this agent.',
  'agents.scopeCollaboratorHelp': 'Collaborators remain limited to tickets in their L1 groups.',
  'agents.manageGroups': 'Manage groups',
  'agents.notInGroup': 'Not in any group yet',
  'agents.groupHelp': 'Add this agent to a group from the Groups screen to control which tickets they see.',
  'agents.about': 'About this agent',
  'agents.aboutBody': 'Name, email, phone, timezone, language and signature identify the agent and personalize their workspace. Role controls what they can do; group membership controls which tickets they see.',

  'dashboard.title': 'Dashboard',
  'dashboard.description': 'Current support workload and service health.',
  'dashboard.allGroups': 'All accessible groups',
  'dashboard.unresolved': 'Unresolved',
  'dashboard.overdue': 'Overdue',
  'dashboard.dueToday': 'Due today',
  'dashboard.open': 'Open',
  'dashboard.onHold': 'On hold',
  'dashboard.unassigned': 'Unassigned',
  'dashboard.awaitingResolutionConfirmation': 'Awaiting resolution confirmation',
  'dashboard.awaitingUserReply': 'Awaiting user reply',
  'dashboard.changeRequests': 'Change requests',
  'dashboard.trends': "Today's trends",
  'dashboard.trendsDescription': 'Ticket creation by UTC hour, compared with yesterday.',
  'dashboard.today': 'Today',
  'dashboard.yesterday': 'Yesterday',
  'dashboard.chartAria': 'Ticket volume by UTC hour, today versus yesterday',
  'dashboard.dataUnavailable': 'Dashboard data is unavailable.',
  'dashboard.loadError': 'Unable to load dashboard data. Please try again.',

  'notifications.title': 'Notifications',
  'notifications.description': 'Your full notification history.',
  'notifications.markAllRead': 'Mark all read',
  'notifications.filter': 'Filter',
  'notifications.allTypes': 'All types',
  'notifications.noType': 'No notifications of this type',
  'notifications.none': 'No notifications yet',
  'notifications.allTypesHint': 'Choose “All types” above to see the rest of your history.',
  'notifications.emptyDescription': 'Assignments, replies, and SLA alerts land here. Tune which ones email you in notification preferences.',
  'notifications.assigned': 'Assigned',
  'notifications.groupAssigned': 'Group assignment',
  'notifications.groupMemberAdded': 'Added to group',
  'notifications.reply': 'Reply',
  'notifications.note': 'Note',
  'notifications.slaWarning': 'SLA warning',
  'notifications.slaBreach': 'SLA breach',
  'notifications.slaEscalation': 'SLA escalation',
  'notifications.mention': 'Mention',

  'preferences.title': 'Notification preferences',
  'preferences.description': 'In-app notifications always stay on. Choose which of them also send an email.',
  'preferences.emailDigest': 'Email digest',
  'preferences.dailySummary': 'Get one daily summary email instead of an email for every event below.',
  'preferences.digestOff': 'Off — email for each event',
  'preferences.digestDaily': 'Daily digest',
  'preferences.digestWarning': 'You’re on the daily digest, so these settings are ignored until you switch it off.',
  'preferences.emailNotifications': 'Email notifications',
  'preferences.createdEvent': 'A ticket is created',
  'preferences.assignedEvent': 'A ticket is assigned to you',
  'preferences.groupAssignedEvent': 'A ticket is assigned to one of your groups',
  'preferences.groupMemberAddedEvent': 'You are added to a support group',
  'preferences.replyEvent': 'A ticket you’re on gets a reply',
  'preferences.noteEvent': 'A private note is added',
  'preferences.slaWarningEvent': 'SLA is approaching its deadline',
  'preferences.slaBreachEvent': 'SLA is breached',
  'preferences.slaEscalationEvent': 'SLA escalates past the deadline',
  'preferences.mentionEvent': 'You’re mentioned on a ticket',
  'preferences.pendingInputEvent': 'A ticket is waiting for your response',
  'preferences.resolvedEvent': 'A ticket is resolved',

  'activities.button': 'Recent activities',
  'activities.title': 'Recent activities',
  'activities.loadError': 'Unable to load recent activities.',
  'activities.systemActor': 'System',
  'activities.noneTitle': 'No recent activity yet',
  'activities.noneDescription': 'Ticket updates from you and your group will appear here as they happen.',

  'tickets.title': 'Tickets',
  'tickets.description': 'Every ticket you have access to, filtered and sorted however you work.',
  'tickets.dueDateTabs': 'Ticket due date',
  'tickets.tabAll': 'All Tickets',
  'tickets.tabDueToday': 'Due Today',
  'tickets.tabOverdue': 'Overdue',
  'tickets.tabDueTomorrow': 'Due Tomorrow',
  'tickets.searchPlaceholder': 'Search tickets…',
  'tickets.searchAria': 'Search tickets',
  'tickets.filters': 'Filters',
  'tickets.filtersWithCount': 'Filters ({count})',
  'tickets.sortAria': 'Sort tickets by',
  'tickets.sortTrigger': 'Sort: {label}',
  'tickets.sortDateCreated': 'Date created',
  'tickets.sortDateUpdated': 'Date updated',
  'tickets.sortPriority': 'Priority',
  'tickets.sortStatus': 'Status',
  'tickets.sortDueDate': 'Due date',
  'tickets.sortAscending': 'Sort ascending',
  'tickets.sortDescending': 'Sort descending',
  'tickets.ascending': 'Ascending',
  'tickets.descending': 'Descending',
  'tickets.layoutAria': 'Row layout',
  'tickets.layoutTrigger': 'Layout: {label}',
  'tickets.layoutCard': 'Card',
  'tickets.layoutInbox': 'Inbox',
  'tickets.layoutTable': 'Table',
  'tickets.export': 'Export',
  'tickets.exportSelected': 'Export selected',
  'tickets.selectedCount': '{count} selected',
  'tickets.assignAgent': 'Assign Agent',
  'tickets.closeAll': 'Close All',
  'tickets.clearSelection': 'Clear',
  'tickets.selectAgentPlaceholder': 'Select agent...',
  'tickets.assignTo': 'Assign to',
  'tickets.assign': 'Assign',
  'tickets.loadFailed': 'Failed to load tickets. Please try again.',
  'tickets.bulkCloseFailed': 'Failed to close the selected tickets. Please try again.',
  'tickets.bulkAssignFailed': 'Failed to assign the selected tickets. Please try again.',
  'tickets.noFilterMatchTitle': 'No tickets match these filters',
  'tickets.noFilterMatchDescription': 'Try removing a filter, widening the date range, or searching for a different term.',
  'tickets.clearFilters': 'Clear filters',
  'tickets.queueClearTitle': 'This queue is clear',
  'tickets.queueClearDescription': 'New tickets appear here as customers email, use the portal, or an agent raises one.',
  'tickets.newTicket': 'New ticket',
  'tickets.selectAllAria': 'Select all tickets',
  'tickets.selectTicketAria': 'Select ticket #{number}',
  'tickets.columnContact': 'Contact',
  'tickets.columnSubject': 'Subject',
  'tickets.columnState': 'State',
  'tickets.columnGroup': 'Group',
  'tickets.columnAgent': 'Agent',
  'tickets.columnPriority': 'Priority',
  'tickets.noGroup': 'No group',
  'tickets.unassigned': 'Unassigned',
  'tickets.createdRelative': 'Created {when}',
  'tickets.unassignedOnly': 'Unassigned only',
  'tickets.unknownRequester': 'Unknown requester',
  'tickets.overdueBy': 'Overdue by {duration}',
  'tickets.dueIn': 'Due in {duration}',
  'tickets.filtersDrawerTitle': 'Filters',
  'tickets.filtersSearchPlaceholder': 'Search fields',
  'tickets.filtersSearchAria': 'Search filter fields',
  'tickets.filtersClearAll': 'Clear all',
  'tickets.filtersApply': 'Apply',
  'tickets.filterAgents': 'Agents',
  'tickets.filterAnyAgent': 'Any agent',
  'tickets.filterGroups': 'Groups',
  'tickets.filterAnyGroup': 'Any group',
  'tickets.filterStatus': 'Status',
  'tickets.filterAnyStatus': 'Any status',
  'tickets.filterPriority': 'Priority',
  'tickets.filterAnyPriority': 'Any priority',
  'tickets.filterSource': 'Source',
  'tickets.filterAnySource': 'Any source',
  'tickets.filterTicketType': 'Ticket type',
  'tickets.filterAnyType': 'Any type',
  'tickets.filterTags': 'Tags',
  'tickets.filterAnyTag': 'Any tag',
  'tickets.filterCompanies': 'Companies',
  'tickets.filterAnyCompany': 'Any company',
  'tickets.filterCreated': 'Created',
  'tickets.filterResolvedAt': 'Resolved at',
  'tickets.filterClosedAt': 'Closed at',
  'tickets.filterDateFrom': '{label} from',
  'tickets.filterDateTo': '{label} to',
  'tickets.filterDateTo2': 'to',
  'tickets.filterAny': 'Any',
  'tickets.chipFieldStatus': 'Status',
  'tickets.chipFieldPriority': 'Priority',
  'tickets.chipFieldGroup': 'Group',
  'tickets.chipFieldAssignee': 'Assignee',
  'tickets.chipValueGroup': 'Group',
  'tickets.chipValueUnassigned': 'Unassigned',

  'ticketDetail.back': 'Back',
  'ticketDetail.follow': 'Follow',
  'ticketDetail.following': 'Following',
  'ticketDetail.hideActivities': 'Hide activities',
  'ticketDetail.activitiesButton': 'Activities',
  'ticketDetail.attachmentsCount': 'Attachments ({count})',
  'ticketDetail.threadAria': 'Ticket thread',
  'ticketDetail.conversationsTabLabel': 'Conversations',
  'ticketDetail.activitiesTabLabel': 'Activities',
  'ticketDetail.noRepliesYet': 'No replies yet',
  'ticketDetail.noRepliesDescription': 'Use the composer below to reply to the requester or add an internal note.',
  'ticketDetail.privateNote': 'Private Note',
  'ticketDetail.forward': 'Forward',
  'ticketDetail.uploadingAria': 'Uploading',
  'ticketDetail.uploadingProgress': 'Uploading {uploading} of {total} file(s)…',
  'ticketDetail.uploadsFailed': '{count} upload(s) failed',
  'ticketDetail.retry': 'Retry',
  'ticketDetail.dismiss': 'Dismiss',
  'ticketDetail.noActivityYet': 'No activity yet',
  'ticketDetail.noActivityDescription': 'Status, agent, and SLA changes will be listed here as the ticket moves.',
  'ticketDetail.requester': 'Requester',
  'ticketDetail.properties': 'Properties',
  'ticketDetail.updating': 'Updating…',
  'ticketDetail.update': 'Update',
  'ticketDetail.tags': 'Tags',
  'ticketDetail.relationships': 'Relationships',
  'ticketDetail.parentTicket': 'Parent ticket',
  'ticketDetail.unlink': 'Unlink',
  'ticketDetail.noParentTicket': 'No parent ticket',
  'ticketDetail.childTicketsCount': 'Child tickets ({count})',
  'ticketDetail.noChildTickets': 'No child tickets',
  'ticketDetail.findTicket': 'Find a ticket',
  'ticketDetail.ticketSearchPlaceholder': 'Ticket number or subject',
  'ticketDetail.searchButton': 'Search',
  'ticketDetail.setParent': 'Set parent',
  'ticketDetail.mergeIntoAction': 'Merge into',
  'ticketDetail.splitIntoChild': 'Split into a child ticket',
  'ticketDetail.newTicketSubjectPlaceholder': 'New ticket subject',
  'ticketDetail.splitButton': 'Split',
  'ticketDetail.copyAttachments': 'Copy attachments',
  'ticketDetail.copyConversationHistory': 'Copy conversation history',
  'ticketDetail.slaLabel': 'SLA',
  'ticketDetail.paused': 'Paused',
  'ticketDetail.editButton': 'Edit',
  'ticketDetail.setResolutionDueDate': 'Set resolution due date',
  'ticketDetail.pickDateTime': 'Pick date & time',
  'ticketDetail.resolutionDueLabel': 'Resolution due',
  'ticketDetail.saveSla': 'Save SLA',
  'ticketDetail.savingSla': 'Saving…',
  'ticketDetail.noSlaPolicy': 'No SLA policy applied to this ticket.',
  'ticketDetail.firstResponse': 'First Response',
  'ticketDetail.resolution': 'Resolution',
  'ticketDetail.done': 'Done',
  'ticketDetail.pausedSince': 'Paused since {date}',
  'ticketDetail.escalation': 'Escalation',
  'ticketDetail.escalatedLevel2': 'Escalated (Level 2)',
  'ticketDetail.escalated': 'Escalated',
  'ticketDetail.dueDateOverridden': 'Due date manually overridden by an admin.',
  'ticketDetail.dates': 'Dates',
  'ticketDetail.created': 'Created',
  'ticketDetail.updated': 'Updated',
  'ticketDetail.resolved': 'Resolved',
  'ticketDetail.closed': 'Closed',
  'ticketDetail.loadErrorTitle': 'Could not load this ticket',
  'ticketDetail.notFound': 'Ticket not found',
  'ticketDetail.confirmMergeTitle': 'Merge ticket #{source} into #{target}?',
  'ticketDetail.confirmMergeDescription': 'The current ticket will be closed. This cannot be undone.',
  'ticketDetail.confirmMergeLabel': 'Merge ticket',
  'ticketDetail.updateSuccess': 'Ticket updated',
  'ticketDetail.updateError': 'Unable to update ticket',
  'ticketDetail.pickDateTitle': 'Pick a date',
  'ticketDetail.pickDateDescription': 'Choose a resolution due date.',
  'ticketDetail.slaUpdateSuccess': 'SLA updated',
  'ticketDetail.slaUpdateError': 'Unable to update SLA',
  'ticketDetail.searchError': 'Unable to search tickets',
  'ticketDetail.parentUpdateError': 'Unable to update parent ticket',
  'ticketDetail.mergeSuccess': 'Merged into #{number}',
  'ticketDetail.mergeError': 'Unable to merge ticket',
  'ticketDetail.splitSuccess': 'Ticket split created',
  'ticketDetail.splitError': 'Unable to split ticket',
  'ticketDetail.downloadError': 'Unable to download attachment',
  'ticketDetail.followSuccess': 'Now following ticket',
  'ticketDetail.unfollowSuccess': 'Stopped following ticket',
  'ticketDetail.watcherError': 'Unable to update watcher status',
  'ticketDetail.fieldsLoadError': 'Unable to load ticket fields',
  'ticketDetail.overdueBy': '{label} overdue',
  'ticketDetail.dueLeft': '{label} left',
  'ticketDetail.presetToday': 'Today',
  'ticketDetail.presetTomorrow': 'Tomorrow',
  'ticketDetail.presetThisWeek': 'This week',
  'ticketDetail.presetNextWeek': 'Next week',
  'ticketDetail.presetThisMonth': 'This month',
  'ticketDetail.eventTicketCreated': 'Ticket created',
  'ticketDetail.eventStatusUpdated': 'Status updated',
  'ticketDetail.eventAgentUpdated': 'Agent updated',
  'ticketDetail.eventSlaUpdated': 'SLA updated',
  'ticketDetail.eventTicketMerged': 'Ticket merged',
  'ticketDetail.eventMergeReceived': 'Merge received',
  'ticketDetail.eventTicketSplit': 'Ticket split',
  'ticketDetail.eventUpdated': 'Updated',
  'ticketDetail.eventSplitContentCopied': 'Split content copied',
  'ticketDetail.eventReplySent': 'Reply sent',
  'ticketDetail.eventNoteAdded': 'Note added',
  'ticketDetail.eventCustomerReplied': 'Customer replied',
  'ticketDetail.eventTicketDeleted': 'Ticket deleted',

  'ui.select': 'Select…',
  'ui.any': 'Any',
  'ui.typeToSearch': 'Type to search…',
  'ui.noResults': 'No results found',
  'ui.clearSelection': 'Clear selection',
  'ui.removeItem': 'Remove {label}',
  'ui.pressEnterToUse': 'Press Enter to use this value',
  'ui.removeFilter': 'Remove filter {field}: {value}',
  'ui.removeTag': 'Remove tag {label}',
  'ui.retry': 'Retry',
  'ui.errorTitle': 'Could not load this content',
  'ui.errorMessage': 'Check your connection and try again.',
  'ui.reference': 'Reference: {id}',
  'ui.thisArea': 'this area',
  'ui.noAccess': 'You do not have access to {area}',
  'ui.noAccessHint': 'Ask an administrator to grant the required permission.',
  'ui.actionFailed': 'Unable to complete this action. Try again.',
  'ui.slaPaused': 'SLA paused',
  'ui.filteredEmptyTitle': 'No tickets match these filters',
  'ui.filteredEmptyDescription': 'Try removing a filter or widening the date range.',
  'ui.clearFilters': 'Clear filters',

  'pagination.noResults': 'No results',
  'pagination.showing': 'Showing {first}–{last} of {total}',
  'pagination.resultsPerPage': 'Results per page',
  'pagination.perPage': '{count} per page',
  'pagination.previous': 'Previous',
  'pagination.next': 'Next',
  'pagination.previousAria': 'Previous page',
  'pagination.nextAria': 'Next page',
  'pagination.pageOf': 'Page {page} of {total}',

  'status.open': 'Open',
  'status.to_be_prioritised': 'To Be Prioritised',
  'status.work_in_progress': 'Work in Progress',
  'status.assigned_to_ai_agent': 'Assigned to AI Agent',
  'status.cto_approval_pending': 'CTO Approval Pending',
  'status.po_approval_pending': 'PO Approval Pending',
  'status.rm_approval_pending': 'RM Approval Pending',
  'status.rework_required': 'Rework Required',
  'status.approved': 'Approved',
  'status.rejected': 'Rejected',
  'status.pending': 'Pending',
  'status.awaiting_user_reply': 'Awaiting User Reply',
  'status.awaiting_resolution_confirmation': 'Awaiting Resolution Confirmation',
  'status.on_hold': 'On Hold',
  'status.pending_production_release': 'Pending Production Release',
  'status.product_cr': 'Product CR',
  'status.reopened': 'Reopened',
  'status.issue_fixed': 'Issue Fixed',
  'status.resolved': 'Resolved',
  'status.closed': 'Closed',
  'status.unknown': 'Unknown',

  'priority.low': 'Low',
  'priority.medium': 'Medium',
  'priority.high': 'High',
  'priority.urgent': 'Urgent',

  'source.email': 'Email',
  'source.portal': 'Portal',
  'source.phone': 'Phone',
  'source.chat': 'Chat',
  'source.whatsapp': 'WhatsApp',
  'source.web_chat': 'Web Chat',
  'source.web_form': 'Web Form',
  'source.forum': 'Forum',
  'source.facebook': 'Facebook',
  'source.mobihelp': 'MobiHelp',
  'source.feedback_widget': 'Feedback Widget',
  'source.outbound_email': 'Outbound Email',
  'source.ecommerce': 'Ecommerce',
  'source.bot': 'Bot',
  'source.instagram_message': 'Instagram Message',
  'source.instagram_comment': 'Instagram Comment',
  'source.facebook_message': 'Facebook Message',
  'source.facebook_comment': 'Facebook Comment',
  'source.mobile_chat_sdk': 'Mobile Chat SDK',
  'source.sms': 'SMS',
  'source.api': 'API',

  'savedViews.title': 'Saved Views',
  'savedViews.saveCurrent': 'Save current filters as a view',
  'savedViews.namePlaceholder': 'View name...',
  'savedViews.nameAria': 'View name',
  'savedViews.empty': 'No saved views. Apply filters and save them here.',
  'savedViews.listAria': 'Saved views list',
  'savedViews.rename': 'Rename view "{name}"',
  'savedViews.delete': 'Delete view "{name}"',

  'export.title': 'Export tickets',
  'export.loadError': 'Unable to load export field list.',
  'export.failed': 'Export failed. Please try again.',
  'export.pdfFailed': 'PDF export failed. Please try again.',
  'export.fieldsSelectedOne': '{count} field selected',
  'export.fieldsSelectedMany': '{count} fields selected',
  'export.fieldsTotalOne': '{count} field total',
  'export.fieldsTotalMany': '{count} fields total',
  'export.selectAllFields': 'Select all fields',
  'export.exportingOne': 'Exporting 1 selected ticket.',
  'export.exportingMany': 'Exporting {count} selected tickets.',
  'export.pdfZip': 'Download as PDF (.zip, {count} files)',
  'export.pdf': 'Download as PDF',
  'export.pdfZipHint': 'Generates one PDF per ticket and compresses them into a single ZIP download.',
  'export.pdfHint': 'Generates a single PDF with ticket properties and the public conversation thread.',
  'export.formatLabel': 'Export as (CSV / Excel)',
  'export.csv': 'CSV',
  'export.excel': 'Excel',
  'export.loadingFields': 'Loading field list…',
  'export.ticketFields': 'Ticket fields',
  'export.contactFields': 'Contact fields',
  'export.companyFields': 'Company fields',
  'export.exporting': 'Exporting…',

  'newTicket.title': 'Create Ticket',
  'newTicket.description': 'Choose a persisted form and complete its fields.',
  'newTicket.form': 'Ticket form',
  'newTicket.noForms': 'No ticket forms are available. Configure a form before creating a ticket.',
  'newTicket.loadFormsError': 'Unable to load ticket forms',
  'newTicket.loadFormError': 'Unable to load the selected ticket form',
  'newTicket.addCc': 'Add CC',
  'newTicket.cc': 'CC',
  'newTicket.removeFile': 'Remove {name}',
  'newTicket.requesterRequired': 'Requester is required',
  'newTicket.subjectRequired': 'Subject is required',
  'newTicket.createFailed': 'Failed to create ticket',
  'newTicket.noFormTitle': 'No ticket form is available',
  'newTicket.noFormDescription': 'Create a ticket form in Settings, then come back to open a ticket.',
  'newTicket.noFieldsTitle': 'This form has no fields yet',
  'newTicket.noFieldsDescription': 'Add fields to the form in Settings, then reload this page.',
  'newTicket.creating': 'Creating...',
  'newTicket.submit': 'Create Ticket',

  'fields.required': '{label} is required',
  'fields.selectParentFirst': 'Select a parent value first...',
  'fields.selectPlaceholder': 'Select {label}...',
  'fields.enterPlaceholder': 'Enter {label}...',
  'fields.optionsLoadError': 'Unable to load {label} options',
  'fields.label.requester': 'Requester',
  'fields.label.subject': 'Subject',
  'fields.label.description': 'Description',
  'fields.label.status': 'Status',
  'fields.label.priority': 'Priority',
  'fields.label.source': 'Source',
  'fields.label.ticket_type': 'Type',
  'fields.label.agent': 'Agent',
  'fields.label.group': 'Group',
  'fields.label.internal_agent': 'Internal Agent',
  'fields.label.internal_group': 'Internal Group',
  'fields.label.company': 'Company',

  'editor.defaultPlaceholder': 'Type here...',
  'editor.ariaLabel': 'Rich text editor',
  'editor.toolbarAria': 'Text formatting',
  'editor.bold': 'Bold (Ctrl+B)',
  'editor.italic': 'Italic (Ctrl+I)',
  'editor.underline': 'Underline (Ctrl+U)',
  'editor.strikethrough': 'Strikethrough',
  'editor.heading1': 'Heading 1',
  'editor.heading2': 'Heading 2',
  'editor.textColor': 'Text color',
  'editor.highlight': 'Highlight',
  'editor.bulletList': 'Bullet List',
  'editor.numberedList': 'Numbered List',
  'editor.blockquote': 'Blockquote',
  'editor.codeBlock': 'Code Block',
  'editor.insertLink': 'Insert Link',
  'editor.insertImage': 'Insert Image',
  'editor.insertTable': 'Insert Table',
  'editor.mention': 'Mention someone',
  'editor.undo': 'Undo (Ctrl+Z)',
  'editor.redo': 'Redo (Ctrl+Shift+Z)',
  'editor.attach': 'Attach file',
  'editor.noAgents': 'No agents found',
  'editor.mentionSuggestions': 'Mention suggestions',
  'editor.dialogLinkTitle': 'Insert link',
  'editor.dialogImageTitle': 'Insert image',
  'editor.linkHint': 'Enter an HTTP(S), mailto, anchor, or relative URL.',
  'editor.imageHint': 'Enter an HTTP(S) or relative image URL.',
  'editor.url': 'URL',
  'editor.invalidLink': 'Enter a valid HTTP(S), mailto, anchor, or relative URL.',
  'editor.invalidImage': 'Enter a valid HTTP(S) or relative image URL.',
  'editor.selectTextForLink': 'Select text before adding a link.',
  'editor.imageInsertFailed': 'The image could not be inserted here.',
  'editor.insertLinkAction': 'Insert link',
  'editor.insertImageAction': 'Insert image',

  'search.dialogAria': 'Global search',
  'search.placeholder': 'Search tickets, contacts...',
  'search.aria': 'Search',
  'search.close': 'Close search',
  'search.noMatches': 'No matches for “{query}”',
  'search.noMatchesHint': 'Try a ticket number, a contact email, or a company name.',
  'search.hintBefore': 'Type at least 2 characters to search. Press',
  'search.hintAfter': 'to close.',

  'td.system': 'System',
  'td.reportedVia': 'reported via {source}',
  'td.recipientTo': 'To',
  'td.recipientCc': 'Cc',
  'td.recipientBcc': 'Bcc',
  'td.notifiedTo': 'Notified to',
  'td.actionCreatedTicket': 'created the ticket',
  'td.actionUpdatedFields': 'updated {fields}',
  'td.fieldStatus': 'status',
  'td.fieldPriority': 'priority',
  'td.fieldSource': 'source',
  'td.fieldType': 'type',
  'td.fieldGroup': 'group',
  'td.fieldAgent': 'agent',
  'td.fieldCompany': 'company',
  'td.fieldContact': 'contact',
  'td.fieldSubject': 'subject',
  'td.fieldDescription': 'description',
  'td.fieldProduct': 'product',
  'td.fieldResolutionDue': 'resolution due date',
  'td.fieldFirstResponseDue': 'first response due date',
  'td.fieldTags': 'tags',
  'td.fieldParentTicket': 'parent ticket',
  'td.eventCreated': '{actor} created a new ticket',
  'td.eventCreatedLinked': '{actor} created a new ticket and linked it to a parent ticket',
  'td.eventSplit': '{actor} split this ticket and created child ticket{ref}',
  'td.eventMergeReceived': '{actor} merged another ticket into this ticket{ref}',
  'td.eventMerged': '{actor} merged this ticket into another ticket{ref}',
  'td.eventSplitCopied': '{actor} copied {conversations} and {attachments}',
  'td.conversationsOne': '{count} conversation',
  'td.conversationsMany': '{count} conversations',
  'td.attachmentsOne': '{count} attachment',
  'td.attachmentsMany': '{count} attachments',
  'td.eventUpdatedFields': '{actor} updated {fields}',
  'td.invalidSlaState': 'The server returned an invalid SLA state.',
  'td.slaRefreshError': 'Unable to refresh SLA clocks.',
  'td.descriptionUpdated': 'Description updated',
  'td.descriptionUpdateError': 'Unable to update description',
  'td.descriptionUpdateFailed': 'Description update failed',
  'td.entryUpdated': 'Entry updated',
  'td.entryUpdateError': 'Unable to update entry',
  'td.updateFailed': 'Update failed',
  'td.loadOlderError': 'Unable to load older conversations',
  'td.loadFailed': 'Load failed',
  'td.slaUpdateFailed': 'SLA update failed',
  'td.reasonTooLong': 'Reason must be 500 characters or fewer.',
  'td.invalidDateTime': 'Choose a valid date and time.',
  'td.slaDeadlineUpdated': 'SLA deadline updated',
  'td.slaConflict': 'The ticket changed while you were editing SLA data. Reload before trying again.',
  'td.slaClearFailed': 'SLA clear failed',
  'td.slaTargetCleared': 'SLA target cleared',
  'td.slaClearError': 'Unable to clear SLA target',
  'td.noDescription': 'No description added yet.',
  'td.editDescriptionAria': 'Edit ticket description',
  'td.download': 'Download',
  'td.downloadFile': 'Download {fileName}',
  'td.loadOlder': '↓ +{count} conversation',
  'td.loadOlderMany': '↓ +{count} conversations',
  'td.edited': '(edited)',
  'td.privateThread': 'Private thread',
  'td.propertiesAria': 'Ticket properties',
  'td.expandProperties': 'Expand properties',
  'td.collapseProperties': 'Collapse properties',
  'td.metric': 'Metric',
  'td.firstResponseOption': 'First response',
  'td.resolutionOption': 'Resolution',
  'td.overrideHint': 'Set a server-authoritative deadline override. The reason is retained in SLA history.',
  'td.deadline': 'Deadline',
  'td.reasonOptional': 'Reason (optional)',
  'td.reasonPlaceholder': 'Approved exception or operational context',
  'td.clearResolutionOverride': 'Clear resolution override',
  'td.clearEscalationTarget': 'Clear escalation target',
  'td.toolsAria': 'Ticket tools and contact',
  'td.ticketContext': 'Ticket context',
  'td.knowledgeBase': 'Knowledge base',
  'td.shortcutsAria': 'Ticket context shortcuts',
  'td.showContext': 'Show ticket context',
  'td.hideContext': 'Hide ticket context',
  'td.openRow': 'Open {label}',
  'td.editTicket': 'Edit ticket',
  'td.searchContactPlaceholder': 'Search contact…',
  'td.describePlaceholder': 'Describe the issue…',
  'td.noAttachments': 'No attachments',

  'tp.api.csrfUnavailable': 'Unable to establish CSRF protection',
  'tp.api.noMfaChallenge': 'No MFA challenge active',
  'tp.api.noMfaSetup': 'No MFA setup challenge active',
  'tp.api.noNewPasswordChallenge': 'No new password challenge active',
  'tp.articles.isLinkedAria': '{title} is linked as a solution',
  'tp.articles.linkAria': 'Link {title} as a solution',
  'tp.articles.linkAsSolution': 'Link as solution',
  'tp.articles.linkedAsSolution': 'Linked as solution',
  'tp.articles.none': 'No suggested articles for this ticket.',
  'tp.articles.title': 'Suggested Articles',
  'tp.articles.views': '{count} views',
  'tp.attachment.loadingPreview': 'Loading preview…',
  'tp.attachment.previewUnavailable': 'Preview unavailable',
  'tp.charts.noData': 'No chart data for this period.',
  'tp.charts.noRecords': 'No records in this period.',
  'tp.charts.period': 'Period',
  'tp.charts.showingTop': 'Showing the top {shown} of {total} segments.',
  'tp.common.cancel': 'Cancel',
  'tp.common.clear': 'Clear',
  'tp.common.loading': 'Loading…',
  'tp.common.send': 'Send',
  'tp.common.sending': 'Sending…',
  'tp.common.system': 'System',
  'tp.convActions.edit': 'Edit',
  'tp.convActions.thread': 'Start a thread',
  'tp.dashboard.new': 'New',
  'tp.dashboard.select': 'Select Dashboard',
  'tp.forward.failed': 'Failed to forward',
  'tp.forward.forwarded': 'Ticket forwarded',
  'tp.forward.forwarding': 'Forwarding…',
  'tp.forward.forwardingMany': 'Forwarding {count} conversations:',
  'tp.forward.forwardingOne': 'Forwarding 1 conversation:',
  'tp.forward.message': 'Message',
  'tp.forward.messagePlaceholder': 'Add a message (optional)…',
  'tp.forward.noContacts': 'No contacts found — type a full email address',
  'tp.forward.recipientEmail': 'Recipient email',
  'tp.forward.recipientInvalid': 'Enter a valid recipient email address',
  'tp.forward.recipientRequired': 'Recipient email is required',
  'tp.forward.searchContact': 'Search contact or type email…',
  'tp.forward.title': 'Forward',
  'tp.forward.to': 'To',
  'tp.forward.useThisEmail': 'Press Enter or click Forward to use this email',
  'tp.jira.addOptional': 'Add Optional Fields',
  'tp.jira.createAndLink': 'Create and Link Issue',
  'tp.jira.createIssue': 'Create Issue',
  'tp.jira.createTitle': 'Create Jira Issue',
  'tp.jira.describePlaceholder': 'Describe the issue…',
  'tp.jira.description': 'Description',
  'tp.jira.development': 'Development',
  'tp.jira.enterDevelopment': 'Enter development',
  'tp.jira.hideOptional': 'Hide Optional Fields',
  'tp.jira.issueId': 'Issue ID',
  'tp.jira.issueSummary': 'Issue Summary',
  'tp.jira.issueType': 'Issue Type *',
  'tp.jira.lastSync': 'Last sync: {error}',
  'tp.jira.linkIssue': 'Link Issue',
  'tp.jira.linkTitle': 'Link Jira Issue',
  'tp.jira.linkedIssues': 'Linked Issues',
  'tp.jira.linkedIssuesHint': 'Use Jira issue keys separated by commas.',
  'tp.jira.linkedIssuesPlaceholder': 'e.g. SUP-123, SUP-456',
  'tp.jira.loadingFields': 'Loading Jira fields…',
  'tp.jira.loadingIssueTypes': 'Loading issue types…',
  'tp.jira.loadingProjects': 'Loading Jira projects…',
  'tp.jira.loadingUsers': 'Loading Jira users…',
  'tp.jira.noLinks': 'No Jira issues linked to this ticket yet.',
  'tp.jira.noneFound': 'No Jira issues found.',
  'tp.jira.notAvailableProject': 'Not available for this project',
  'tp.jira.projects': 'Projects *',
  'tp.jira.refresh': 'Refresh',
  'tp.jira.refreshFields': 'Refresh Jira fields',
  'tp.jira.reporter': 'Reporter',
  'tp.jira.requestFailed': 'Jira request failed. Please try again.',
  'tp.jira.searchBy': 'Search by:',
  'tp.jira.searchIssue': 'Search issue',
  'tp.jira.searchIssuePlaceholder': 'Search issue…',
  'tp.jira.searchUsers': 'Search Jira users',
  'tp.jira.searching': 'Searching Jira…',
  'tp.jira.selectIssueType': 'Select an issue type',
  'tp.jira.selectProject': 'Select a project',
  'tp.jira.summary': 'Summary *',
  'tp.jira.syncOff': 'Sync off',
  'tp.jira.syncOn': 'Sync on',
  'tp.jira.syncStatus': 'Sync ticket status to Jira',
  'tp.jira.unassigned': 'Unassigned',
  'tp.jira.unlink': 'Unlink',
  'tp.jira.unlinkConfirm': 'Unlink issue',
  'tp.jira.unlinkDescription': 'This removes the connection from the ticket but does not delete the Jira issue.',
  'tp.jira.unlinkTitle': 'Unlink {key}?',
  'tp.jira.untitled': 'Untitled Jira issue',
  'tp.layout.loadingPage': 'Loading page…',
  'tp.notFound.goToDashboard': 'Go to Dashboard',
  'tp.notFound.title': 'Page not found',
  'tp.portal.brand': 'SuzukiDesk Support',
  'tp.portal.customer': 'Customer',
  'tp.reply.addNote': 'Add Note',
  'tp.reply.attachmentNotAdded': 'Attachment not added',
  'tp.reply.clickToExpand': 'Click to expand',
  'tp.reply.collapsedNote': 'Add an internal note…',
  'tp.reply.collapsedReply': 'Write a reply or note…',
  'tp.reply.conversationType': 'Conversation type',
  'tp.reply.failedToSend': 'Failed to send',
  'tp.reply.markNoteAs': 'Mark note as',
  'tp.reply.notVisibleToContact': 'Not visible to contact',
  'tp.reply.notVisibleToContacts': 'Not visible to contacts',
  'tp.reply.noteAdded': 'Note added',
  'tp.reply.notifyTo': 'Notify to',
  'tp.reply.placeholderPrivateNote': 'Add a private note...',
  'tp.reply.placeholderPublicNote': 'Add a public note visible to the requester...',
  'tp.reply.placeholderReply': 'Type your reply...',
  'tp.reply.private': 'Private',
  'tp.reply.public': 'Public',
  'tp.reply.removeFile': 'Remove {name}',
  'tp.reply.replySent': 'Reply sent',
  'tp.reply.searchAgentsToNotify': 'Search agents to notify…',
  'tp.reply.sendReply': 'Send Reply',
  'tp.reply.sending': 'Sending...',
  'tp.reply.tabNote': 'Note',
  'tp.reply.tabReply': 'Reply',
  'tp.reply.uploadAttachment': 'Upload attachment',
  'tp.reply.visibleToContact': 'Visible to contact',
  'tp.reply.visibleToContacts': 'Visible to contacts',
  'tp.sla.breached': 'Breached',
  'tp.sla.cleared': 'Cleared',
  'tp.sla.configErrorNoDeadline': 'SLA configuration error. No deadline is being inferred.',
  'tp.sla.configurationError': 'Configuration error',
  'tp.sla.couldNotLoad': 'Could not load SLA clocks',
  'tp.sla.done': 'Done',
  'tp.sla.dueIn': 'Due in {duration}',
  'tp.sla.dueLine': 'Due: {date}',
  'tp.sla.dueNow': 'Due now',
  'tp.sla.escalated': 'Escalated',
  'tp.sla.firstResponse': 'First response',
  'tp.sla.invalidDeadline': 'Invalid deadline',
  'tp.sla.mayBeStale': 'SLA clocks may be stale',
  'tp.sla.noActiveCycle': 'No active SLA cycle.',
  'tp.sla.noDeadline': 'No deadline',
  'tp.sla.noMetrics': 'No SLA metrics are available for this cycle.',
  'tp.sla.noPolicy': 'No SLA policy applied to this ticket.',
  'tp.sla.notConfigured': 'Not configured',
  'tp.sla.notStarted': 'Not started',
  'tp.sla.overdueBy': 'Overdue by {duration}',
  'tp.sla.overridden': 'Overridden',
  'tp.sla.overrideReason': 'Override reason: {reason}',
  'tp.sla.paused': 'Paused',
  'tp.sla.refreshing': 'Refreshing authoritative SLA clocks…',
  'tp.sla.resolution': 'Resolution',
  'tp.sla.stopsSla': 'Stops SLA',
  'tp.thread.empty': 'Nothing has been sent yet. Your first message will start this private thread.',
  'tp.thread.messageFailed': 'Message failed',
  'tp.thread.privateThread': 'Private thread',
  'tp.thread.replyPlaceholder': 'Reply in thread…',
  'tp.thread.someone': 'Someone',
  'tp.thread.startPrivateThread': 'Start a private thread',
  'tp.thread.startedBy': '{name} started this thread',
  'tp.thread.unableToSend': 'Unable to send message',
  'tp.ui.breadcrumb': 'Breadcrumb',
  'tp.ui.closePanel': 'Close panel',
  'tp.ui.dismiss': 'Dismiss {title}',

  'dir.loadError': 'Unable to load data. Please try again.',
  'dir.contacts.description': 'Customer contacts and their support history.',
  'dir.contacts.searchAria': 'Search contacts',
  'dir.contacts.count': '{count} contacts',
  'dir.contacts.noMatch': 'No contacts match this search',
  'dir.contacts.none': 'No contacts yet',
  'dir.contacts.noneDescription': 'Contacts appear here once customers start submitting tickets.',
  'dir.company': 'Company',
  'dir.unnamedContact': 'Unnamed contact',
  'dir.contact': 'Contact',
  'dir.contactNotFound': 'Contact not found.',
  'dir.confirmDeleteContactTitle': 'Delete “{name}”?',
  'dir.thisContact': 'this contact',
  'dir.confirmDeleteContactDescription': 'Contacts with tickets will be deactivated instead of permanently deleted.',
  'dir.deleteContact': 'Delete contact',
  'dir.editProfile': 'Edit profile',
  'dir.profile': 'Profile',
  'dir.firstName': 'First name',
  'dir.lastName': 'Last name',
  'dir.phone': 'Phone',
  'dir.timezone': 'Timezone',
  'dir.emailLabel': 'Email:',
  'dir.phoneLabel': 'Phone:',
  'dir.companyLabel': 'Company:',
  'dir.timezoneLabel': 'Timezone:',
  'dir.recentTickets': 'Recent tickets',
  'dir.noTicketsYet': 'No tickets yet',
  'dir.contactTicketsDescription': 'Tickets raised by this contact will be listed here.',
  'dir.ticket': 'Ticket',
  'dir.subject': 'Subject',
  'dir.status': 'Status',
  'dir.created': 'Created',
  'dir.companies.description': 'Organizations linked to customer contacts and tickets.',
  'dir.companies.add': 'Add company',
  'dir.companies.domain': 'Domain',
  'dir.companies.create': 'Create company',
  'dir.companies.searchAria': 'Search companies',
  'dir.companies.searchPlaceholder': 'Search companies or domains',
  'dir.companies.noMatch': 'No companies match this search',
  'dir.companies.addFirst': 'Add your first company',
  'dir.companies.tryDifferent': 'Try a different company name or domain.',
  'dir.companies.useForm': 'Use the form beside this list to create a company.',
  'dir.companies.contacts': 'Contacts',
  'dir.companies.tickets': 'Tickets',
  'dir.companies.notFound': 'Company not found.',
  'dir.companies.confirmDeleteTitle': 'Delete “{name}”?',
  'dir.companies.thisCompany': 'this company',
  'dir.companies.confirmDeleteDescription': 'The company must have no contacts or tickets before it can be deleted.',
  'dir.companies.delete': 'Delete company',
  'dir.companies.noDomain': 'No domain configured',
  'dir.companies.contactsCount': 'Contacts ({count})',
  'dir.companies.ticketsCount': 'Tickets ({count})',
  'dir.companies.noContactsDescription': 'Add a contact and link it to this company to see it here.',
  'dir.companies.noTicketsDescription': "Tickets raised by this company's contacts will be listed here.",
  'dir.trendsCreatedHour': 'Created date - Hour of the Day',
  'dir.reports.loadError': 'Unable to load this report. Please try again.',
  'dir.reports.volume': 'Ticket volume',
  'dir.reports.sla': 'SLA compliance',
  'dir.reports.agents': 'Agent performance',
  'dir.reports.csat': 'Customer satisfaction',
  'dir.reports.rca': 'Root cause analysis',
  'dir.reports.descVolume': 'See where tickets are coming from and how they move through the lifecycle.',
  'dir.reports.descSla': 'Track response and resolution targets across the accessible support operation.',
  'dir.reports.descAgents': 'Compare workload, outcomes, replies, and average handling times by agent.',
  'dir.reports.descCsat': 'Read customer sentiment without mistaking response volume for satisfaction rate.',
  'dir.reports.descRca': 'Find the standardized root causes behind ticket demand.',
  'dir.reports.noPayload': 'No report payload was returned for this period.',
  'dir.reports.refresh': 'Refresh',
  'dir.reports.report': 'Report',
  'dir.reports.from': 'From',
  'dir.reports.to': 'To',
  'dir.reports.maxRange': 'Maximum range: 90 days · scope follows your account permissions.',
  'dir.reports.unclassified': 'Unclassified',
  'dir.reports.ticketsInPeriod': 'Tickets in period',
  'dir.reports.ticketsInPeriodDetail': 'Accessible tickets returned by the report',
  'dir.reports.created': 'Created',
  'dir.reports.createdDetail': 'Across the selected date axis',
  'dir.reports.resolved': 'Resolved',
  'dir.reports.resolvedDetail': '{percent}% of created volume',
  'dir.reports.noCreated': 'No created tickets',
  'dir.reports.reopened': 'Reopened',
  'dir.reports.reopenedDetail': 'Lifecycle events, not unique tickets',
  'dir.reports.dailyPulse': 'Daily pulse',
  'dir.reports.volumeByDate': 'Ticket volume by date',
  'dir.reports.volumeByDateDescription': 'Sparse backend rows are expanded into a complete zero-filled date axis.',
  'dir.reports.createdTickets': 'Created tickets',
  'dir.reports.createdVolumeAria': 'Created ticket volume by date',
  'dir.reports.lifecycle': 'Lifecycle',
  'dir.reports.lifecycleTitle': 'Created, resolved, reopened',
  'dir.reports.lifecycleDescription': 'A three-line view of movement through the ticket lifecycle.',
  'dir.reports.lifecycleAria': 'Ticket lifecycle events by date',
  'dir.reports.dimensions': 'Dimensions',
  'dir.reports.whereConcentrated': 'Where volume is concentrated',
  'dir.reports.topEight': 'Top eight segments shown per panel',
  'dir.reports.status': 'Status',
  'dir.reports.statusDescription': 'Current ticket status',
  'dir.reports.priority': 'Priority',
  'dir.reports.priorityDescription': 'Ticket priority mix',
  'dir.reports.group': 'Group',
  'dir.reports.groupDescription': 'Routing groups',
  'dir.reports.agent': 'Agent',
  'dir.reports.agentDescription': 'Assigned ownership',
  'dir.reports.product': 'Product',
  'dir.reports.productDescription': 'Product mix',
  'dir.reports.country': 'Country',
  'dir.reports.countryDescription': 'From standardized country fields',
  'dir.reports.noRecords': 'No records in this period.',
  'dir.reports.slaSummary': '{rate} · {met} of {total} met',
  'dir.reports.noSlaSegments': 'No SLA segments yet',
  'dir.reports.noSlaSegmentsDescription': 'There are no applicable SLA records for this dimension in the selected period.',
  'dir.reports.segment': 'Segment',
  'dir.reports.firstResponse': 'First response',
  'dir.reports.resolution': 'Resolution',
  'dir.reports.avgFirstResponse': 'Avg. first response',
  'dir.reports.avgResolution': 'Avg. resolution',
  'dir.reports.fromTicketMetric': 'From TicketMetric',
  'dir.reports.slaLens': 'SLA lens',
  'dir.reports.performanceBySegment': 'Performance by segment',
  'dir.reports.slaRatesNote': 'Rates use only records with an applicable SLA target. Durations are average elapsed time.',
  'dir.reports.slaDimensionAria': 'SLA breakdown dimension',
  'dir.reports.rosterSignal': 'Roster signal',
  'dir.reports.agentPerformance': 'Agent performance',
  'dir.reports.agentPerformanceDescription': 'Every active agent is included, including agents with zero activity.',
  'dir.reports.filterAgentsAria': 'Filter agents',
  'dir.reports.filterAgentsPlaceholder': 'Filter by agent or email',
  'dir.reports.matchingAgents': '{count} matching agents',
  'dir.reports.activeAgents': '{count} active agents',
  'dir.reports.sortedBy': 'sorted by {key} {direction}',
  'dir.reports.asc': 'ascending',
  'dir.reports.desc': 'descending',
  'dir.reports.noAgentsMatch': 'No agents match this filter',
  'dir.reports.assigned': 'Assigned',
  'dir.reports.replies': 'Replies',
  'dir.reports.csatScore': 'CSAT score',
  'dir.reports.csatScoreDetail': 'Ratings of 4 or 5',
  'dir.reports.averageRating': 'Average rating',
  'dir.reports.averageRatingDetail': 'Across rated surveys',
  'dir.reports.ratedSurveys': 'Rated surveys',
  'dir.reports.ratedSurveysDetail': 'In the selected period',
  'dir.reports.satisfied': 'Satisfied',
  'dir.reports.satisfiedDetail': 'Positive responses',
  'dir.reports.responseTrend': 'Response trend',
  'dir.reports.surveyVolume': 'Survey volume by date',
  'dir.reports.surveyVolumeDescription': 'The backend returns response count by date; this is not a daily score. latest 100 responses are sampled below.',
  'dir.reports.surveyResponses': 'Survey responses',
  'dir.reports.surveyVolumeAria': 'CSAT survey response volume by date',
  'dir.reports.responsesByGroup': 'Responses by group',
  'dir.reports.responsesByGroupDescription': 'Survey response count, not a group satisfaction rate',
  'dir.reports.responsesByAgent': 'Responses by agent',
  'dir.reports.responsesByAgentDescription': 'Survey response count, not an agent satisfaction rate',
  'dir.reports.customerVoice': 'Customer voice',
  'dir.reports.latestSurveys': 'Latest survey responses',
  'dir.reports.boundedSample': 'Bounded sample · {count} of max 100',
  'dir.reports.latestSurveysNote': 'Newest responses returned by the reporting API. Use this table for a quick read, not a complete export.',
  'dir.reports.noSurveys': 'No survey responses',
  'dir.reports.noSurveysDescription': 'CSAT responses will appear here once customers rate a resolved ticket.',
  'dir.reports.rating': 'Rating',
  'dir.reports.comment': 'Comment',
  'dir.reports.received': 'Received',
  'dir.reports.ratingOutOf': '{rating} out of 5',
  'dir.reports.noComment': 'No comment',
  'dir.reports.rcaEyebrow': 'Root cause analysis',
  'dir.reports.rcaTitle': 'Why tickets are being raised',
  'dir.reports.rcaDescription': 'Category and subcategory are independent aggregates from the standardized ticket custom fields.',
  'dir.reports.rcaDimensionAria': 'RCA dimension',
  'dir.reports.category': 'Category',
  'dir.reports.subcategory': 'Subcategory',
  'dir.reports.rcaEmpty': 'No root-cause values were recorded for this period.',
  'dir.kb.articleLoadError': 'Unable to load the article.',
  'dir.kb.articleNotFound': 'Article not found.',
  'dir.kb.retry': 'Retry',
  'dir.kb.title': 'Knowledge Base',
  'dir.kb.breadcrumb': 'Knowledge base',
  'dir.kb.description': '{articles} articles across {folders} folders',
  'dir.kb.newArticle': 'New Article',
  'dir.kb.editArticle': 'Edit Article',
  'dir.kb.sectionsAria': 'Knowledge base sections',
  'dir.kb.tabArticles': 'Articles',
  'dir.kb.tabStructure': 'Categories & Folders',
  'dir.kb.folderFilterAria': 'Folder filter',
  'dir.kb.allArticles': 'All articles ({count})',
  'dir.kb.writeFirst': 'Write your first article',
  'dir.kb.writeFirstDescription': 'Use New Article to add content to this folder.',
  'dir.kb.byAuthor': 'by {name}',
  'dir.kb.views': '{count} views',
  'dir.kb.published': 'Published',
  'dir.kb.draft': 'Draft',
  'dir.kb.publish': 'Publish',
  'dir.kb.unpublish': 'Unpublish',
  'dir.kb.noFolders': 'No folders in this category',
  'dir.kb.noFoldersDescription': 'Add a folder to start grouping articles.',
  'dir.kb.articlesCount': '{count} articles',
  'dir.kb.fieldTitle': 'Title',
  'dir.kb.folder': 'Folder',
  'dir.kb.selectFolder': 'Select folder',
  'dir.kb.content': 'Content',
  'dir.kb.contentPlaceholder': 'Write your article content...',
  'dir.kb.tags': 'Tags (comma-separated)',
  'dir.kb.attachments': 'Attachments',
  'dir.kb.download': 'Download',
  'dir.kb.downloadFile': 'Download {name}',
  'dir.kb.remove': 'Remove',
  'dir.kb.removeFile': 'Remove {name}',
  'dir.kb.noAttachments': 'No attachments yet.',
  'dir.kb.uploadAria': 'Upload attachment',
  'dir.kb.uploading': 'Uploading...',
  'dir.kb.addFile': 'Add file',
  'dir.kb.confirmDeleteTitle': 'Delete article?',
  'dir.kb.confirmDeleteDescription': 'This published or draft article will be permanently deleted.',
  'dir.kb.confirmDeleteLabel': 'Delete article',
  'dir.kb.confirmRemoveTitle': 'Remove attachment?',
  'dir.kb.confirmRemoveDescription': 'The file will be permanently removed from this article.',
  'dir.kb.confirmRemoveLabel': 'Remove attachment',
  'dir.reports.rangeInvalid': 'Choose valid start and end dates.',
  'dir.reports.rangeOrder': 'The end date must be on or after the start date.',
  'dir.reports.rangeMax': 'Reports support a maximum date range of 90 days.',

  'adm.active': 'Active',
  'adm.auto.action.add_tag': 'add tag',
  'adm.auto.action.assign_agent': 'assign agent',
  'adm.auto.action.assign_group': 'assign group',
  'adm.auto.action.send_email': 'send email',
  'adm.auto.action.send_notification': 'send notification',
  'adm.auto.action.set_priority': 'set priority',
  'adm.auto.action.set_status': 'set status',
  'adm.auto.actions': 'Actions',
  'adm.auto.addAction': '+ Add action',
  'adm.auto.addCondition': '+ Add condition',
  'adm.auto.addRule': 'Add rule',
  'adm.auto.colApplied': 'Actions applied',
  'adm.auto.colDate': 'Date',
  'adm.auto.colMatched': 'Matched',
  'adm.auto.colSubject': 'Subject',
  'adm.auto.colTicket': 'Ticket',
  'adm.auto.conditions': 'Conditions',
  'adm.auto.confirmDesc': 'This rule will stop running immediately and cannot be restored.',
  'adm.auto.confirmLabel': 'Delete rule',
  'adm.auto.confirmTitle': 'Delete automation rule?',
  'adm.auto.countMany': '{count} automation rules',
  'adm.auto.countOne': '{count} automation rule',
  'adm.auto.create': 'Create',
  'adm.auto.createFirst': 'Create your first automation rule',
  'adm.auto.createFirstDesc': 'Use Add rule to route, prioritize, or notify automatically.',
  'adm.auto.deleteFailed': 'Delete failed',
  'adm.auto.description': 'Rules run sequentially by position. Conditions are AND-ed within a rule.',
  'adm.auto.editRule': 'Edit automation rule',
  'adm.auto.execFailed': 'Failed to load executions',
  'adm.auto.field.assigneeId': 'assignee',
  'adm.auto.field.companyId': 'company',
  'adm.auto.field.groupId': 'group',
  'adm.auto.field.priority': 'priority',
  'adm.auto.field.requesterId': 'requester',
  'adm.auto.field.source': 'source',
  'adm.auto.field.status': 'status',
  'adm.auto.field.subject': 'subject',
  'adm.auto.field.ticketTypeId': 'ticket type',
  'adm.auto.hits': 'Hits',
  'adm.auto.loadFailed': 'Failed to load automation rules',
  'adm.auto.log': 'Log',
  'adm.auto.logTitle': 'Execution log — {name}',
  'adm.auto.moveDown': 'Move down',
  'adm.auto.moveUp': 'Move up',
  'adm.auto.newRule': 'New automation rule',
  'adm.auto.no': 'No',
  'adm.auto.noRuns': 'No runs recorded yet',
  'adm.auto.noRunsDesc': 'Executions appear here the first time this rule matches a ticket.',
  'adm.auto.op.contains': 'contains',
  'adm.auto.op.ends_with': 'ends with',
  'adm.auto.op.greater_than': 'greater than',
  'adm.auto.op.in': 'in',
  'adm.auto.op.is': 'is',
  'adm.auto.op.is_empty': 'is empty',
  'adm.auto.op.is_not': 'is not',
  'adm.auto.op.is_not_empty': 'is not empty',
  'adm.auto.op.less_than': 'less than',
  'adm.auto.op.not_contains': 'not contains',
  'adm.auto.op.not_in': 'not in',
  'adm.auto.op.starts_with': 'starts with',
  'adm.auto.reorderFailed': 'Reorder failed',
  'adm.auto.saveFailed': 'Save failed',
  'adm.auto.stopProcessing': 'Stop processing subsequent rules',
  'adm.auto.title': 'Automation rules',
  'adm.auto.toggleFailed': 'Toggle failed',
  'adm.auto.trigger': 'Trigger *',
  'adm.auto.trigger.ticket_creation': 'Ticket creation',
  'adm.auto.trigger.ticket_update': 'Ticket update',
  'adm.auto.trigger.time_trigger': 'Time-based',
  'adm.auto.triggerCol': 'Trigger',
  'adm.auto.valuePlaceholder': 'Value',
  'adm.auto.yes': 'Yes',
  'adm.close': 'Close',
  'adm.deleting': 'Deleting...',
  'adm.description': 'Description',
  'adm.descriptionLabel': 'Description',
  'adm.edit': 'Edit',
  'adm.email.addChannel': 'Add channel',
  'adm.email.addTitle': 'Add email channel',
  'adm.email.colEmail': 'Email',
  'adm.email.colReplyTo': 'Reply-to',
  'adm.email.colSmtp': 'SMTP',
  'adm.email.confirmDesc': 'This channel will no longer be available for support mail.',
  'adm.email.confirmLabel': 'Delete channel',
  'adm.email.confirmTitle': 'Delete email channel?',
  'adm.email.countMany': '{count} email channels',
  'adm.email.countOne': '{count} email channel',
  'adm.email.create': 'Create',
  'adm.email.createFirst': 'Add your first email channel',
  'adm.email.createFirstDesc': 'Use Add channel to connect a support address so replies reach this desk.',
  'adm.email.default': 'Default',
  'adm.email.defaultChannel': 'Default channel',
  'adm.email.deleteFailed': 'Delete failed',
  'adm.email.description': 'Manage inbound/outbound email addresses, SMTP configuration, and reply-to settings.',
  'adm.email.editTitle': 'Edit email channel',
  'adm.email.emailAddress': 'Email address *',
  'adm.email.loadFailed': 'Failed to load email configs',
  'adm.email.outbound': 'Outbound SMTP',
  'adm.email.replyTo': 'Reply-to address',
  'adm.email.replyToPh': '(defaults to email address)',
  'adm.email.saveFailed': 'Save failed',
  'adm.email.sesGlobal': 'SES (global)',
  'adm.email.smtpHost': 'SMTP host',
  'adm.email.smtpHostPh': 'e.g. email-smtp.eu-central-1.amazonaws.com',
  'adm.email.smtpPassword': 'SMTP password',
  'adm.email.smtpPort': 'SMTP port',
  'adm.email.smtpUser': 'SMTP user',
  'adm.email.title': 'Email channels',
  'adm.groups.aboutBody': "Members determine which agents see this group's tickets by default. Business hours governs SLA timing for tickets routed here, and the escalation contact is notified in addition to the assignee when a ticket breaches its SLA.",
  'adm.groups.aboutTitle': 'About this group',
  'adm.groups.accountDefault': 'Account default',
  'adm.groups.activeAgentMany': '{count} active agents',
  'adm.groups.activeAgentOne': '{count} active agent',
  'adm.groups.activeAgents': 'Active agents',
  'adm.groups.addMember': 'Add member',
  'adm.groups.assignment': 'Assignment',
  'adm.groups.autoAssign': 'Automatic assignment',
  'adm.groups.autoAssignNote': 'Ticket assignment is always manual in this product - there is no round-robin or load-based routing. This toggle does not change that.',
  'adm.groups.businessHours': 'Business hours',
  'adm.groups.colGroup': 'Group',
  'adm.groups.confirmDesc': 'Tickets and templates using this group must be reassigned first.',
  'adm.groups.confirmLabel': 'Delete group',
  'adm.groups.confirmTitle': 'Delete “{name}”?',
  'adm.groups.createFirst': 'Create your first group',
  'adm.groups.defaultHours': 'Default hours',
  'adm.groups.editAria': 'Edit {name}',
  'adm.groups.editGroup': 'Edit Group',
  'adm.groups.escalateHelp': 'Added as a notification recipient when a ticket in this group breaches its SLA.',
  'adm.groups.escalateTo': 'Escalate to',
  'adm.groups.escalatesTo': 'Escalates to',
  'adm.groups.escalatesToName': 'Escalates to {name}',
  'adm.groups.escalationBody': 'When a ticket in this group breaches its SLA, the escalation contact is added as a notification recipient alongside the assignee and group members.',
  'adm.groups.escalationTitle': 'Escalation contact',
  'adm.groups.hoursHelp': 'Used for SLA calculations on tickets in this group.',
  'adm.groups.manageAgents': 'Manage agents',
  'adm.groups.manageHours': 'Manage business hours',
  'adm.groups.manual': 'Manual',
  'adm.groups.manualBody': 'Assignment is manual in this product - there is no round-robin or load-based auto-assignment. The "Automatic assignment" toggle on a group only affects whether new tickets in that group default to unassigned or fall back to an existing routing rule; agents still pick up and hand off tickets themselves.',
  'adm.groups.manualTitle': 'Manual assignment',
  'adm.groups.memberMany': '{count} members',
  'adm.groups.memberOne': '{count} member',
  'adm.groups.members': 'Members',
  'adm.groups.newGroup': 'New Group',
  'adm.groups.noEscalation': 'No escalation contact',
  'adm.groups.noMatch': 'No groups match this search',
  'adm.groups.noMembers': 'No members yet',
  'adm.groups.noMembersDesc': 'Pick an active agent above and select Add member.',
  'adm.groups.remove': 'Remove',
  'adm.groups.routing': 'Routing',
  'adm.groups.routingMethod': 'Routing method',
  'adm.groups.saved': 'Group saved.',
  'adm.groups.searchAria': 'Search groups',
  'adm.groups.searchPlaceholder': 'Search by name',
  'adm.groups.selectActiveAgent': 'Select active agent',
  'adm.groups.showing': 'Showing {start}-{end} of {total}',
  'adm.groups.subtitle': 'Groups control ticket routing and visibility. Assign agents as members, and pick a business-hours schedule and escalation contact for each group.',
  'adm.groups.title': 'Groups',
  'adm.groups.tryDifferent': 'Try a different group name.',
  'adm.groups.unassigned': 'Unassigned',
  'adm.groups.useNew': 'Use New Group to route tickets to a set of agents.',
  'adm.groups.zero': '0 groups',
  'adm.inactive': 'Inactive',
  'adm.jira.accepted': 'Connection accepted',
  'adm.jira.accountEmail': 'Jira account email',
  'adm.jira.accountEmailLabel': 'Account email',
  'adm.jira.activeConn': 'Active connection',
  'adm.jira.addConnection': 'Add connection',
  'adm.jira.addTitle': 'Add Jira connection',
  'adm.jira.added': 'Jira connection added',
  'adm.jira.apiToken': 'API token',
  'adm.jira.clearSecret': 'Clear saved webhook secret',
  'adm.jira.confirmDesc': 'This removes the saved connection and its ticket links. Jira issues are not deleted.',
  'adm.jira.confirmLabel': 'Delete connection',
  'adm.jira.confirmTitle': 'Delete {name}?',
  'adm.jira.connName': 'Connection name',
  'adm.jira.connNamePh': 'Engineering Jira',
  'adm.jira.connectedAs': 'Connected as {name}',
  'adm.jira.connectionDesk': 'Connection desk',
  'adm.jira.default': 'Default',
  'adm.jira.defaultConn': 'Default connection',
  'adm.jira.defaultIssueType': 'Default issue type',
  'adm.jira.defaultProjectKey': 'Default project key',
  'adm.jira.defaults': 'Defaults',
  'adm.jira.description': 'Connect account-owned Jira sites so agents can link issues and keep ticket status in step.',
  'adm.jira.editTitle': 'Edit Jira connection',
  'adm.jira.footer': 'Create the Jira webhook with the endpoint shown above, subscribe to issue updated events, and use the same webhook secret configured here.',
  'adm.jira.heading': 'Keep support and engineering in the same loop',
  'adm.jira.intro': 'Credentials are stored encrypted on the server and never returned to this screen. Configure a webhook secret when Jira should send status changes back to SuzukiDesk.',
  'adm.jira.no': 'No',
  'adm.jira.noConns': 'No Jira connections yet',
  'adm.jira.noConnsDesc': 'Add a connection to make Jira actions available from ticket detail.',
  'adm.jira.noProject': 'No project',
  'adm.jira.pasteToken': 'Paste token',
  'adm.jira.requestFailed': 'Jira request failed. Please try again.',
  'adm.jira.savedToast': 'Jira connection saved',
  'adm.jira.secretConfigured': 'Secret configured: {value}',
  'adm.jira.secretHint': 'Use the same secret when creating the Jira webhook.',
  'adm.jira.secretOptional': 'Optional, 16+ characters',
  'adm.jira.siteUrl': 'Jira site URL',
  'adm.jira.siteUrlHint': 'Do not include credentials in the URL.',
  'adm.jira.syncFromJira': 'Jira status back to ticket',
  'adm.jira.syncSnapshot': 'Linked issue snapshot',
  'adm.jira.syncToJira': 'Ticket status to Jira',
  'adm.jira.testConnection': 'Test connection',
  'adm.jira.testFailed': 'Connection test failed',
  'adm.jira.title': 'Jira integration',
  'adm.jira.tokenHintEdit': 'Leave blank to keep the current token.',
  'adm.jira.tokenHintNew': 'Stored encrypted; it will not be shown again.',
  'adm.jira.tokenMissing': 'API token missing',
  'adm.jira.tokenStored': 'API token stored',
  'adm.jira.unchanged': '(unchanged if blank)',
  'adm.jira.verified': 'Jira connection verified',
  'adm.jira.webhookEndpoint': 'Jira webhook endpoint',
  'adm.jira.webhookSecret': 'Webhook secret',
  'adm.jira.whatSyncs': 'What syncs',
  'adm.jira.yes': 'Yes',
  'adm.nameRequired': 'Name *',
  'adm.nextPage': 'Next page',
  'adm.notif.aud.all': 'Shared',
  'adm.notif.aud.customer': 'Customer',
  'adm.notif.aud.internal': 'Internal',
  'adm.notif.audEmail': '{audience} email',
  'adm.notif.body': 'Body',
  'adm.notif.description': 'Customize each notification audience without sending customers into the internal workspace.',
  'adm.notif.discardDesc': 'Your unsaved changes to this notification template will be lost if you switch templates.',
  'adm.notif.discardLabel': 'Discard changes',
  'adm.notif.discardTitle': 'Discard unsaved changes?',
  'adm.notif.discarded': 'Unsaved changes discarded.',
  'adm.notif.event.automation_notification': 'Automation notification',
  'adm.notif.event.group_member_added': 'Added to group',
  'adm.notif.event.mention': 'Mention',
  'adm.notif.event.pending_input': 'Pending input',
  'adm.notif.event.sla_breach': 'SLA breach',
  'adm.notif.event.sla_escalation': 'SLA escalation',
  'adm.notif.event.sla_warning': 'SLA warning',
  'adm.notif.event.ticket_assigned': 'Ticket assigned',
  'adm.notif.event.ticket_created': 'Ticket created',
  'adm.notif.event.ticket_first_response': 'First response',
  'adm.notif.event.ticket_group_assigned': 'Ticket assigned to group',
  'adm.notif.event.ticket_note': 'Private note',
  'adm.notif.event.ticket_public_note': 'Public note',
  'adm.notif.event.ticket_reply': 'Ticket reply',
  'adm.notif.event.ticket_resolved': 'Ticket resolved',
  'adm.notif.events': 'Events',
  'adm.notif.eventsHelp': 'Choose an event and recipient audience.',
  'adm.notif.insertVar': 'Insert {variable}',
  'adm.notif.linkNoteAgent': 'The audience-aware link variable {variable} opens the agent workspace for this email.',
  'adm.notif.linkNoteCustomer': 'The audience-aware link variable {variable} opens the customer portal for this email.',
  'adm.notif.off': 'off',
  'adm.notif.preview': 'Preview',
  'adm.notif.previewNotice': 'Preview rendered with sample data.',
  'adm.notif.rendering': 'Rendering…',
  'adm.notif.route.all': 'Uses the recipient-aware ticket link for the delivery audience.',
  'adm.notif.route.customer': 'The primary action opens the customer portal ticket.',
  'adm.notif.route.internal': 'The primary action opens the agent workspace ticket.',
  'adm.notif.sampleOnlyAgent': 'Sample data only — the primary action targets the agent workspace route.',
  'adm.notif.sampleOnlyCustomer': 'Sample data only — the primary action targets the customer portal route.',
  'adm.notif.saveChanges': 'Save changes',
  'adm.notif.saved': 'Template saved.',
  'adm.notif.savedBtn': 'Saved',
  'adm.notif.selectEvent': 'Select an event to edit its template',
  'adm.notif.selectEventDesc': 'Pick a notification event on the left to change its subject and body.',
  'adm.notif.sendTest': 'Send test email',
  'adm.notif.sending': 'Sending…',
  'adm.notif.subject': 'Subject',
  'adm.notif.testQueued': 'Test email queued to {email}.',
  'adm.notif.title': 'Notification templates',
  'adm.notif.urlVarTitle': 'Audience-aware link variable',
  'adm.notif.useTemplate': 'Use this template for this audience',
  'adm.notif.useTemplateHelp': 'Turning it off uses the safe fallback notification.',
  'adm.notif.variables': 'Variables',
  'adm.notif.variablesHelp': 'Click to append to the message body',
  'adm.pagination': 'Pagination',
  'adm.perm.cap.admin.label': 'Access the administration console',
  'adm.perm.cap.assign.label': 'Assign a ticket',
  'adm.perm.cap.close.label': 'Close a ticket',
  'adm.perm.cap.conversation_delete.label': 'Delete a posted reply or note',
  'adm.perm.cap.conversation_edit.label': 'Edit a posted reply or note',
  'adm.perm.cap.create.label': 'Create a ticket',
  'adm.perm.cap.delete.label': 'Delete a ticket',
  'adm.perm.cap.edit.label': 'Edit ticket properties',
  'adm.perm.cap.export.label': 'Export tickets',
  'adm.perm.cap.field_admin.label': 'Ticket fields',
  'adm.perm.cap.form_admin.label': 'Ticket forms',
  'adm.perm.cap.forward.label': 'Forward a ticket',
  'adm.perm.cap.jira_link.label': 'Link and manage Jira issues',
  'adm.perm.cap.kb.label': 'Access the knowledge base',
  'adm.perm.cap.manage_agents.label': 'Agents',
  'adm.perm.cap.manage_api_keys.label': 'API keys',
  'adm.perm.cap.manage_automations.label': 'Automations',
  'adm.perm.cap.manage_canned_responses.label': 'Canned responses',
  'adm.perm.cap.manage_email_config.label': 'Email',
  'adm.perm.cap.manage_groups.label': 'Groups',
  'adm.perm.cap.manage_jira.label': 'Jira integration',
  'adm.perm.cap.manage_kb.label': 'Knowledge base',
  'adm.perm.cap.manage_notification_templates.label': 'Notification templates',
  'adm.perm.cap.manage_roles.label': 'Roles',
  'adm.perm.cap.manage_tags.label': 'Tags',
  'adm.perm.cap.note.label': 'Add or edit private notes',
  'adm.perm.cap.reassign.label': 'Reassign a ticket already owned by someone else',
  'adm.perm.cap.reopen.label': 'Reopen a resolved or closed ticket',
  'adm.perm.cap.reply.label': 'Reply publicly to the customer',
  'adm.perm.cap.report_access.label': 'View reports and dashboards',
  'adm.perm.cap.reports.label': 'Access the reporting module',
  'adm.perm.cap.resolve.label': 'Resolve a ticket',
  'adm.perm.cap.settings_admin.label': 'Open the Settings section (required to see the Settings nav item and its index page; access to each page below is still controlled independently)',
  'adm.perm.cap.sla_admin.label': 'SLA policies & business hours',
  'adm.perm.cap.sla_edit.desc': 'Separate from the Settings > SLA policies permission below — this only covers editing due dates on an individual ticket.',
  'adm.perm.cap.sla_edit.label': "Manually override a ticket's SLA due dates",
  'adm.perm.cap.tag.label': 'Manage ticket tags',
  'adm.perm.cap.thread_start.label': 'Start a private thread on a conversation entry',
  'adm.perm.cap.tickets.label': 'Access the ticket workspace',
  'adm.perm.cap.view.label': 'View tickets in scope',
  'adm.perm.cat.administration.desc': 'Access to the admin console and its configuration screens.',
  'adm.perm.cat.administration.label': 'Administration',
  'adm.perm.cat.knowledge.desc': 'Reading and using knowledge content while working a ticket.',
  'adm.perm.cat.knowledge.label': 'Knowledge base',
  'adm.perm.cat.reporting.desc': 'Operational reporting and dashboards.',
  'adm.perm.cat.reporting.label': 'Reporting',
  'adm.perm.cat.settings-pages.desc': 'Grant access to each Settings screen individually. Nothing is visible until it is explicitly checked here.',
  'adm.perm.cat.settings-pages.label': 'Settings pages',
  'adm.perm.cat.tickets.desc': 'What an agent can do inside the ticket workspace.',
  'adm.perm.cat.tickets.label': 'Tickets',
  'adm.previousPage': 'Previous page',
  'adm.refresh': 'Refresh',
  'adm.roleType.administrator': 'Administrator',
  'adm.roleType.agent': 'Agent',
  'adm.roleType.collaborator': 'Collaborator',
  'adm.roleType.customer': 'Customer',
  'adm.roleType.super_admin': 'Super admin',
  'adm.roleType.supervisor': 'Supervisor',
  'adm.roles.activeHelp': 'Active - inactive roles cannot be assigned to agents',
  'adm.roles.agentCan': 'Agent can',
  'adm.roles.agentType': 'Agent Type',
  'adm.roles.agentsAssignedNote': 'Agents are assigned this role from the Agents screen.',
  'adm.roles.agentsCount': '{count} Agents',
  'adm.roles.agentsLabel': 'Agents',
  'adm.roles.agentsManage': '{count} Agents - Manage',
  'adm.roles.builtIn': '(Built-in)',
  'adm.roles.builtInNote': 'This is a built-in role. It can be renamed and deactivated, but not deleted.',
  'adm.roles.builtInTitle': 'Built-in role: editable and deactivatable, but cannot be deleted',
  'adm.roles.categoriesAria': 'Permission categories',
  'adm.roles.confirmDesc': 'Agents assigned to this role will need another role before it can be removed.',
  'adm.roles.confirmLabel': 'Delete role',
  'adm.roles.createFirst': 'Create your first role',
  'adm.roles.createFirstDesc': 'Use New Role to define the capabilities agents should get.',
  'adm.roles.editRole': 'Edit Role',
  'adm.roles.granted': '{count} granted',
  'adm.roles.heading': 'Agent Roles',
  'adm.roles.inactive': 'Inactive',
  'adm.roles.newRole': 'New Role',
  'adm.roles.noAgent': 'No Agent',
  'adm.roles.notEnforced': '(not enforced yet)',
  'adm.roles.notEnforcedTitle': 'Stored on the role but not yet gated anywhere at runtime',
  'adm.roles.permissions': 'Permissions',
  'adm.roles.saved': 'Role saved.',
  'adm.roles.scopeBody': 'Capabilities combine with row-level scope (all / group / assigned / own), so an agent only ever acts on tickets they can already see.',
  'adm.roles.scopeTitle': 'Scope still applies',
  'adm.roles.scrollTo': 'Scroll to',
  'adm.roles.status': 'Status',
  'adm.roles.subtitle': 'Provide and restrict fine-grained levels of access and privileges for agents.',
  'adm.roles.title': 'Roles',
  'adm.roles.typeLocked': 'Agent type cannot be changed once you save a role.',
  'adm.roles.understandingBody1': 'Roles decide what an agent can do. Create a role, tick the capabilities it should grant, then assign it to agents from the Agents screen.',
  'adm.roles.understandingBody2': 'Built-in roles can be renamed and deactivated but never deleted. A role that still has agents assigned cannot be deleted either, so move those agents first.',
  'adm.roles.understandingTitle': 'Understanding Roles',
  'adm.saveChanges': 'Save changes',
  'adm.settings.add': 'Add {name}',
  'adm.settings.back': 'Back to settings',
  'adm.settings.cannedDesc': 'Account responses available to you while working a ticket.',
  'adm.settings.cannedEmpty': 'No canned responses yet',
  'adm.settings.cannedEmptyDesc': 'Ask an administrator to add shared responses your team can reuse on a ticket.',
  'adm.settings.cannedTitle': 'Canned responses',
  'adm.settings.col.autoAssign': 'Auto Assign',
  'adm.settings.col.color': 'Color',
  'adm.settings.col.content': 'Content',
  'adm.settings.col.createdAt': 'Created At',
  'adm.settings.col.description': 'Description',
  'adm.settings.col.email': 'Email',
  'adm.settings.col.expiresAt': 'Expires At',
  'adm.settings.col.fieldType': 'Field Type',
  'adm.settings.col.firstName': 'First Name',
  'adm.settings.col.folderId': 'Folder Id',
  'adm.settings.col.hitCount': 'Hit Count',
  'adm.settings.col.holidays': 'Holidays',
  'adm.settings.col.host': 'Host',
  'adm.settings.col.hours': 'Hours',
  'adm.settings.col.id': 'ID',
  'adm.settings.col.isActive': 'Is Active',
  'adm.settings.col.isBuiltIn': 'Is Built In',
  'adm.settings.col.isDefault': 'Is Default',
  'adm.settings.col.isRequired': 'Is Required',
  'adm.settings.col.isShared': 'Is Shared',
  'adm.settings.col.isSystem': 'Is System',
  'adm.settings.col.key': 'Key',
  'adm.settings.col.label': 'Label',
  'adm.settings.col.language': 'Language',
  'adm.settings.col.lastName': 'Last Name',
  'adm.settings.col.lastUsedAt': 'Last Used At',
  'adm.settings.col.name': 'Name',
  'adm.settings.col.options': 'Options',
  'adm.settings.col.phone': 'Phone',
  'adm.settings.col.port': 'Port',
  'adm.settings.col.position': 'Position',
  'adm.settings.col.prefix': 'Prefix',
  'adm.settings.col.priority': 'Priority',
  'adm.settings.col.required': 'Required',
  'adm.settings.col.role': 'Role',
  'adm.settings.col.roleId': 'Role Id',
  'adm.settings.col.scopes': 'Scopes',
  'adm.settings.col.slug': 'Slug',
  'adm.settings.col.status': 'Status',
  'adm.settings.col.stopProcessing': 'Stop Processing',
  'adm.settings.col.timezone': 'Timezone',
  'adm.settings.col.title': 'Title',
  'adm.settings.col.trigger': 'Trigger',
  'adm.settings.col.type': 'Type',
  'adm.settings.col.updatedAt': 'Updated At',
  'adm.settings.col.usageCount': 'Usage Count',
  'adm.settings.col.username': 'Username',
  'adm.settings.confirmDesc': 'This cannot be undone.',
  'adm.settings.confirmTitle': 'Delete {name}?',
  'adm.settings.count': '{count} {title}',
  'adm.settings.create': 'Create',
  'adm.settings.empty': 'No {title} yet',
  'adm.settings.emptyAdd': 'Use the form above to add your first {name}.',
  'adm.settings.emptyOther': 'Entries appear here once they are configured.',
  'adm.settings.homeDesc': 'Configure users, ticket workflows, service levels, and integrations.',
  'adm.settings.manage': 'Manage {title}.',
  'adm.settings.noPages': 'No settings pages available',
  'adm.settings.noPagesDesc': 'Ask a super admin to grant access to the settings pages you need.',
  'adm.settings.notFound': 'Settings page not found',
  'adm.settings.notFoundDesc': 'Pick a settings area to continue.',
  'adm.settings.res.agents.field.email': 'Email',
  'adm.settings.res.agents.field.firstName': 'First name',
  'adm.settings.res.agents.field.lastName': 'Last name',
  'adm.settings.res.agents.field.password': 'Temporary password',
  'adm.settings.res.agents.field.roleId': 'Role ID',
  'adm.settings.res.agents.one': 'agent',
  'adm.settings.res.agents.title': 'Agents',
  'adm.settings.res.api-keys.field.name': 'Key name',
  'adm.settings.res.api-keys.one': 'API key',
  'adm.settings.res.api-keys.title': 'API keys',
  'adm.settings.res.automations.field.description': 'Description',
  'adm.settings.res.automations.field.name': 'Name',
  'adm.settings.res.automations.one': 'automation',
  'adm.settings.res.automations.title': 'Automations',
  'adm.settings.res.business-hours.field.name': 'Name',
  'adm.settings.res.business-hours.field.timezone': 'Timezone',
  'adm.settings.res.business-hours.one': 'business hours entry',
  'adm.settings.res.business-hours.title': 'Business hours',
  'adm.settings.res.canned-responses.field.content': 'Response content',
  'adm.settings.res.canned-responses.field.title': 'Title',
  'adm.settings.res.canned-responses.one': 'canned response',
  'adm.settings.res.canned-responses.title': 'Canned responses',
  'adm.settings.res.email.field.host': 'SMTP host',
  'adm.settings.res.email.field.name': 'Name',
  'adm.settings.res.email.field.port': 'SMTP port',
  'adm.settings.res.email.field.username': 'Username',
  'adm.settings.res.email.one': 'email configuration',
  'adm.settings.res.email.title': 'Email configuration',
  'adm.settings.res.fields.one': 'ticket field',
  'adm.settings.res.fields.title': 'Ticket fields',
  'adm.settings.res.forms.field.label': 'Display label',
  'adm.settings.res.forms.field.name': 'Field name',
  'adm.settings.res.forms.field.type': 'Field type',
  'adm.settings.res.forms.one': 'form or custom field',
  'adm.settings.res.forms.title': 'Forms and custom fields',
  'adm.settings.res.groups.field.description': 'Description',
  'adm.settings.res.groups.field.name': 'Name',
  'adm.settings.res.groups.one': 'group',
  'adm.settings.res.groups.title': 'Groups',
  'adm.settings.res.jira.one': 'Jira integration',
  'adm.settings.res.jira.title': 'Jira integration',
  'adm.settings.res.kb.field.content': 'Article content',
  'adm.settings.res.kb.field.folderId': 'Folder ID',
  'adm.settings.res.kb.field.title': 'Article title',
  'adm.settings.res.kb.one': 'knowledge base article',
  'adm.settings.res.kb.title': 'Knowledge base administration',
  'adm.settings.res.notification-templates.one': 'notification template',
  'adm.settings.res.notification-templates.title': 'Notification templates',
  'adm.settings.res.roles.field.description': 'Description',
  'adm.settings.res.roles.field.name': 'Name',
  'adm.settings.res.roles.field.type': 'Role type',
  'adm.settings.res.roles.one': 'role',
  'adm.settings.res.roles.title': 'Roles',
  'adm.settings.res.sla.field.description': 'Description',
  'adm.settings.res.sla.field.name': 'Name',
  'adm.settings.res.sla.one': 'SLA policy',
  'adm.settings.res.sla.title': 'SLA policies',
  'adm.settings.res.tags.field.name': 'Name',
  'adm.settings.res.tags.one': 'tag',
  'adm.settings.res.tags.title': 'Tags',
  'adm.settings.title': 'Settings',
  'adm.status': 'Status',

  'sla.edit': 'Edit',
  'sla.active': 'Active',
  'sla.inactive': 'Inactive',
  'sla.default': 'Default',
  'sla.yes': 'Yes',
  'sla.no': 'No',
  'sla.description': 'Description',
  'sla.status': 'Status',
  'sla.notConfigured': 'Not configured',
  'sla.minutesValue': '{value} minutes',
  'sla.invalidServerValue': 'Invalid server value',
  'sla.statusSemantics.title': 'Ticket status semantics',
  'sla.statusSemantics.description': 'Each active status has an explicit SLA contract. A pausing status and a status that stops SLA are mutually exclusive.',
  'sla.statusSemantics.conflict': 'A status cannot pause SLA and stop SLA at the same time.',
  'sla.statusSemantics.emptyTitle': 'No status definitions',
  'sla.statusSemantics.emptyDescription': 'Status definitions will appear here once configured for this account.',
  'sla.statusSemantics.colPauses': 'Pauses SLA',
  'sla.statusSemantics.colStops': 'Stops SLA',
  'sla.statusSemantics.pausesAria': '{label} pauses SLA',
  'sla.statusSemantics.stopsAria': '{label} stops SLA',
  'sla.preview.title': 'Read-only ticket preview',
  'sla.preview.description': 'Run the same account-scoped evaluator used by live SLA cycles. This preview never writes a policy or ticket.',
  'sla.preview.priority': 'Priority',
  'sla.preview.group': 'Group',
  'sla.preview.anyGroup': 'Any group',
  'sla.preview.company': 'Company',
  'sla.preview.anyCompany': 'Any company',
  'sla.preview.source': 'Source',
  'sla.preview.anySource': 'Any source',
  'sla.preview.ticketType': 'Ticket type',
  'sla.preview.anyTicketType': 'Any ticket type',
  'sla.preview.representativeStart': 'Representative start',
  'sla.preview.calculating': 'Calculating…',
  'sla.preview.run': 'Run preview',
  'sla.preview.configAttention': 'Configuration needs attention',
  'sla.preview.selectedPolicy': 'Selected policy',
  'sla.preview.noPolicy': 'No policy',
  'sla.preview.evaluationOrder': 'Evaluation order',
  'sla.preview.firstMatching': 'First matching policy',
  'sla.preview.calculationMode': 'Calculation mode',
  'sla.preview.modeBusinessHours': 'Business hours',
  'sla.preview.modeBusinessHoursNamed': 'Business hours · {name}',
  'sla.preview.mode247': '24/7 elapsed time',
  'sla.preview.modeNone': 'Not calculated',
  'sla.preview.thresholds': 'Independent thresholds',
  'sla.preview.colMetric': 'Metric',
  'sla.preview.colTarget': 'Target',
  'sla.preview.colWarning': 'Warning',
  'sla.preview.colDue': 'Due / breach',
  'sla.preview.colEscalation': 'Escalation',
  'sla.preview.colState': 'State',
  'sla.preview.metricFirstResponse': 'First response',
  'sla.preview.metricResolution': 'Resolution',
  'sla.preview.trace': 'Policy evaluation trace',
  'sla.preview.selected': 'Selected',
  'sla.preview.matchedAfterSelection': 'Matched after selection',
  'sla.preview.skipped': 'Skipped',
  'sla.preview.showTrace': 'Show calculation trace',
  'sla.state.not_configured': 'not configured',
  'sla.state.running': 'running',
  'sla.state.paused': 'paused',
  'sla.state.warning': 'warning',
  'sla.state.breached': 'breached',
  'sla.state.met': 'met',
  'sla.state.escalated': 'escalated',
  'sla.state.pending': 'pending',
  'sla.state.stopped': 'stopped',
  'sla.state.on_track': 'on track',
  'sla.state.at_risk': 'at risk',
  'sla.list.subtitle': 'Set first-response and resolution targets per priority. Policies are evaluated top to bottom — the first one whose conditions match a ticket wins.',
  'sla.list.newPolicy': 'New Policy',
  'sla.list.emptyTitle': 'Create your first SLA policy',
  'sla.list.emptyDescription': 'Use New Policy to set first-response and resolution targets per priority.',
  'sla.list.moveUp': 'Move up',
  'sla.list.moveDown': 'Move down',
  'sla.list.frShort': 'FR: {value}',
  'sla.list.resolveShort': 'Resolve: {value}',
  'sla.list.escalateShort': 'Escalate: +{value}',
  'sla.list.deactivate': 'Deactivate',
  'sla.list.activate': 'Activate',
  'sla.list.setDefault': 'Set Default',
  'sla.list.duplicate': 'Duplicate',
  'sla.list.deleteTitle': 'Delete “{name}”?',
  'sla.list.deleteDescription': 'Tickets matched to this policy will use the next available SLA policy.',
  'sla.list.deleteConfirm': 'Delete policy',
  'sla.conditions.groups': '{count} group(s)',
  'sla.conditions.companies': '{count} company(ies)',
  'sla.conditions.sources': 'sources: {list}',
  'sla.conditions.ticketTypes': '{count} ticket type(s)',
  'sla.conditions.anyOf': 'any of',
  'sla.conditions.allOf': 'all of',
  'sla.conditions.summary': 'Conditions ({mode}): {parts}',
  'sla.edit.newTitle': 'New SLA Policy',
  'sla.edit.editTitle': 'Edit SLA Policy',
  'sla.edit.saved': 'SLA policy saved.',
  'sla.edit.name': 'Name',
  'sla.edit.appliesToPriority': 'Applies to priority',
  'sla.edit.evaluationOrder': 'Evaluation order',
  'sla.edit.evaluationOrderHint': 'Lower positions are evaluated first for this account.',
  'sla.edit.defaultPolicy': 'Default policy',
  'sla.edit.useAsDefault': 'Use as default when no other policy matches',
  'sla.edit.targets': 'SLA targets',
  'sla.edit.firstResponse': 'First response',
  'sla.edit.resolution': 'Resolution',
  'sla.edit.autoAt75': 'Automatic at 75%',
  'sla.edit.enabledAfter': 'Enabled after {value}',
  'sla.edit.clearEscalation': 'Explicitly clear escalation target',
  'sla.edit.clearEscalationHint': 'Sends null; leaving this unchecked omits the field and preserves the saved value.',
  'sla.edit.firstResponseMinutes': 'First response (minutes)',
  'sla.edit.resolutionMinutes': 'Resolution (minutes)',
  'sla.edit.escalateAfter': 'Escalate after (minutes past resolution due)',
  'sla.edit.notSet': 'Not set',
  'sla.edit.remindersNote': "Reminders fire automatically at 75% of the first-response and resolution windows. Escalation notifies the ticket's group escalation agent (set on the group) once the resolution target has been missed by the configured number of minutes.",
  'sla.edit.conditions': 'Conditions',
  'sla.edit.conditionsHint': 'Leave a group unchecked to match all values',
  'sla.edit.matchMode': 'Match mode:',
  'sla.edit.matchAll': 'Match ALL conditions',
  'sla.edit.matchAny': 'Match ANY condition',
  'sla.edit.groups': 'Groups',
  'sla.edit.companies': 'Companies',
  'sla.edit.sources': 'Sources',
  'sla.edit.ticketTypes': 'Ticket Types',
  'sla.bh.subtitle': 'Define the weekly schedule and holiday calendar SLA policies use to calculate due dates.',
  'sla.bh.newCalendar': 'New Calendar',
  'sla.bh.emptyTitle': 'Create your first business hours calendar',
  'sla.bh.emptyDescription': 'Use New Calendar to define the weekly schedule SLA policies count against.',
  'sla.bh.accountDefault': 'Account default',
  'sla.bh.closedEveryDay': 'Closed every day',
  'sla.bh.openEveryDay': 'Open every day',
  'sla.bh.openDaysOne': 'Open 1 day/week',
  'sla.bh.openDaysMany': 'Open {count} days/week',
  'sla.bh.holidayOne': '1 holiday',
  'sla.bh.holidayMany': '{count} holidays',
  'sla.bh.deleteTitle': 'Delete “{name}”?',
  'sla.bh.deleteDescription': 'SLA policies and groups using this schedule will fall back to the account default.',
  'sla.bh.deleteConfirm': 'Delete schedule',
  'sla.bh.newTitle': 'New Business Hours Calendar',
  'sla.bh.editTitle': 'Edit Business Hours',
  'sla.bh.saved': 'Business hours saved.',
  'sla.bh.timezone': 'Timezone',
  'sla.bh.defaultCalendar': 'Default calendar',
  'sla.bh.useAsDefault': "Use for SLA policies and groups that don't specify their own calendar",
  'sla.bh.weeklySchedule': 'Weekly schedule',
  'sla.bh.colDay': 'Day',
  'sla.bh.colOpen': 'Open',
  'sla.bh.colStart': 'Start',
  'sla.bh.colEnd': 'End',
  'sla.bh.dayOpenAria': '{day} open',
  'sla.bh.dayStartAria': '{day} start time',
  'sla.bh.dayEndAria': '{day} end time',
  'sla.bh.holidayCalendar': 'Holiday calendar',
  'sla.bh.saveFirst': 'Save this calendar first, then add holidays.',
  'sla.bh.holidayName': 'Holiday name',
  'sla.bh.date': 'Date',
  'sla.bh.addHoliday': 'Add holiday',
  'sla.bh.noHolidays': 'No holidays yet',
  'sla.bh.noHolidaysHint': 'Add a dated holiday above to exclude it from SLA calculations.',
  'sla.bh.remove': 'Remove',
  'sla.day.monday': 'Monday',
  'sla.day.tuesday': 'Tuesday',
  'sla.day.wednesday': 'Wednesday',
  'sla.day.thursday': 'Thursday',
  'sla.day.friday': 'Friday',
  'sla.day.saturday': 'Saturday',
  'sla.day.sunday': 'Sunday',

  'set.ftype.single_line_text': 'Single-line text',
  'set.ftype.multi_line_text': 'Multi-line text',
  'set.ftype.dropdown': 'Dropdown',
  'set.ftype.checkbox': 'Checkbox',
  'set.ftype.radio': 'Radio',
  'set.ftype.multiselect': 'Multi-select',
  'set.ftype.lookup': 'Lookup relationship',
  'set.ftype.dependent': 'Dependent field',
  'set.ftype.date': 'Date',
  'set.ftype.number': 'Number',
  'set.ftype.decimal': 'Decimal',
  'set.ftype.desc.lookup': 'Select a record from a system source.',
  'set.ftype.desc.single_line_text': 'Short text value.',
  'set.ftype.desc.multi_line_text': 'Long-form text value.',
  'set.ftype.desc.checkbox': 'True or false value.',
  'set.ftype.desc.dropdown': 'Select one normalized option.',
  'set.ftype.desc.dependent': 'Options depend on a parent field.',
  'set.ftype.desc.date': 'Calendar date value.',
  'set.ftype.desc.number': 'Whole-number value.',
  'set.ftype.desc.decimal': 'Decimal-number value.',
  'set.src.STATIC': 'Static options',
  'set.src.AGENTS': 'Agents',
  'set.src.USERS': 'Users / Customers',
  'set.src.GROUPS': 'Groups',
  'set.src.ROLE': 'Roles',
  'set.src.COUNTRIES': 'Countries',
  'set.src.CUSTOM': 'Custom dropdown list',
  'set.settings': 'Settings',
  'set.ticketFields': 'Ticket Fields',
  'set.ticketForms': 'Ticket Forms',
  'set.requestFailed': 'Request failed. Please try again.',
  'set.refresh': 'Refresh',
  'set.saving': 'Saving…',
  'set.saveChanges': 'Save changes',
  'set.default': 'Default',
  'set.published': 'Published',
  'set.draft': 'Draft',
  'set.publish': 'Publish',
  'set.unpublish': 'Unpublish',
  'set.deleteForm': 'Delete form',
  'set.description': 'Description',
  'set.relationshipSource': 'Relationship source',
  'set.dependsOn': 'Depends on {field}',
  'set.deleteFormTitle': 'Delete “{name}”?',
  'set.deleteFormDescription': 'This ticket form and its configuration will be permanently deleted.',
  'set.formIdRequired': 'A form id is required.',
  'set.formNotFound': 'Ticket form not found.',
  'set.tf.removeOption': 'Remove {label}',
  'set.tf.noOptions': 'No options defined yet.',
  'set.tf.addOptionPlaceholder': 'Add option...',
  'set.tf.add': 'Add',
  'set.tf.dependsOnField': 'Depends on field',
  'set.tf.selectParent': '— Select parent field —',
  'set.tf.parentHelp': "The parent dropdown field whose selected value determines this field's available options.",
  'set.tf.optionMappings': 'Option mappings',
  'set.tf.savingParen': '(saving...)',
  'set.tf.mappingsError': 'Unable to load mappings',
  'set.tf.archivedParen': ' (archived)',
  'set.tf.mappedCount': '{count} mapped',
  'set.tf.saveFirst': 'Save the field first to configure option mappings.',
  'set.tf.newField': 'New {type}',
  'set.tf.pageDescription': 'Manage imported field definitions, visibility, required rules, and the order used by ticket forms.',
  'set.tf.addField': 'Add field',
  'set.tf.addFieldHelp': 'Drag a type into the field list or use Add.',
  'set.tf.addType': 'Add {type}',
  'set.tf.registry': 'Field registry',
  'set.tf.savingOrder': 'Saving order…',
  'set.tf.searchAria': 'Search ticket fields',
  'set.tf.searchPlaceholder': 'Search by name or key...',
  'set.tf.filterAria': 'Filter by field type',
  'set.tf.allTypes': 'All field types',
  'set.tf.emptyFirstTitle': 'Add your first ticket field',
  'set.tf.emptyFirstDesc': 'Drag a field type from the palette or use Add to create one.',
  'set.tf.emptyFilterTitle': 'No fields match these filters',
  'set.tf.emptyFilterDesc': 'Try a different search term or widen the field type filter.',
  'set.tf.archived': 'Archived',
  'set.tf.dependent': 'Dependent',
  'set.tf.customerVisible': 'Customer visible',
  'set.tf.internal': 'Internal',
  'set.tf.configuration': 'Field configuration',
  'set.tf.selectTitle': 'Select a field to configure',
  'set.tf.selectDesc': 'Pick a field from the registry to edit its labels, rules, and visibility.',
  'set.tf.externalId': 'External ID: {value}',
  'set.tf.sourceRenderer': 'Source: {source} · Renderer: {renderer}',
  'set.tf.optionSource': 'Option source: {value}',
  'set.tf.dependsOnKey': 'Depends on: {value}',
  'set.tf.internalLabel': 'Internal label',
  'set.tf.customerLabel': 'Customer label',
  'set.tf.relationshipHelp': 'Determines where lookup values are fetched from at runtime.',
  'set.tf.validationVisibility': 'Validation and visibility',
  'set.tf.requiredAgents': 'Required for agents',
  'set.tf.requiredCustomers': 'Required for customers',
  'set.tf.requiredClosure': 'Required for closure',
  'set.tf.displayedCustomers': 'Displayed to customers',
  'set.tf.customersEdit': 'Customers can edit',
  'set.tf.customersFilter': 'Customers can filter',
  'set.tf.active': 'Active',
  'set.tf.dropdownOptions': 'Dropdown options ({count})',
  'set.tf.archiveTitle': 'Archive “{name}”?',
  'set.tf.archiveDesc': 'The field will become inactive and unavailable for new tickets. Existing ticket data is preserved.',
  'set.tf.archiveField': 'Archive field',
  'set.tf.alreadyArchived': 'Already archived',
  'set.tf.archivedNote': 'Archived fields remain available for historical values.',
  'set.tfm.systemUser': 'System',
  'set.tfm.untitled': 'Untitled form',
  'set.tfm.pageDescription': 'Create reusable forms and choose which imported fields agents and customers can use.',
  'set.tfm.newForm': 'New form',
  'set.tfm.creating': 'Creating…',
  'set.tfm.allForms': 'All forms',
  'set.tfm.configuredOne': '{count} configured form',
  'set.tfm.configuredMany': '{count} configured forms',
  'set.tfm.filter': 'Filter',
  'set.tfm.searchAria': 'Search ticket forms',
  'set.tfm.searchPlaceholder': 'Search forms…',
  'set.tfm.status': 'Status',
  'set.tfm.allStatuses': 'All statuses',
  'set.tfm.emptyFilterTitle': 'No forms match these filters',
  'set.tfm.emptyFilterDesc': 'Try a different search term or widen the status filter.',
  'set.tfm.emptyFirstTitle': 'Create your first ticket form',
  'set.tfm.emptyFirstDesc': 'Create a form to start configuring imported fields.',
  'set.tfm.createFirst': 'Create your first form',
  'set.tfm.colName': 'Name',
  'set.tfm.colCreatedAt': 'Created at',
  'set.tfm.colUpdatedBy': 'Last updated by',
  'set.tfm.colUpdatedAt': 'Last updated at',
  'set.tfm.colPortals': 'Associated portals',
  'set.tfm.colActions': 'Actions',
  'set.tfm.notConfigured': 'Not configured',
  'set.tfm.actionsFor': 'Actions for {name}',
  'set.tfm.editForm': 'Edit form',
  'set.tb.section.default.title': 'Default fields',
  'set.tb.section.default.desc': 'Core support workflow fields imported from the source system.',
  'set.tb.section.custom.title': 'Custom fields',
  'set.tb.section.custom.desc': 'Additional fields configured for your support process.',
  'set.tb.section.nested.title': 'Nested fields',
  'set.tb.section.nested.desc': 'Dependent fields whose options follow a parent field.',
  'set.tb.discardTitle': 'Discard unsaved changes?',
  'set.tb.discardDesc': 'Your edits to this ticket form have not been saved.',
  'set.tb.leave': 'Leave without saving',
  'set.tb.nameRequired': 'Form name is required.',
  'set.tb.saved': 'Form saved.',
  'set.tb.nowPublished': 'Form published.',
  'set.tb.nowUnpublished': 'Form unpublished.',
  'set.tb.admin': 'Admin',
  'set.tb.builder': 'Builder',
  'set.tb.titleAria': 'Form title',
  'set.tb.defaultLocked': 'Default / locked',
  'set.tb.previewPortal': 'Preview on portal',
  'set.tb.configureTitle': 'Configure the fields included in this form.',
  'set.tb.configureDesc': 'Changes are persisted to the support desk database when you select Save changes. Required fields stay enabled.',
  'set.tb.formDetails': 'Form details',
  'set.tb.formDetailsHelp': 'Use a clear description so administrators know when to use this form.',
  'set.tb.descPlaceholder': 'Describe when this form should be used…',
  'set.tb.importedFields': 'Imported fields',
  'set.tb.importedHelp': 'Drag to reorder fields. Use the switch to include or exclude a field from this form.',
  'set.tb.noneInSection': 'No imported fields in this section.',
  'set.tb.dragReorder': 'Drag to reorder',
  'set.tb.required': 'Required',
  'set.tb.nested': 'Nested',
  'set.tb.enableField': 'Enable {label}',
  'set.tb.enabled': 'Enabled',
  'set.tb.disabled': 'Disabled',
  'set.tb.emptyTitle': 'No fields to configure yet',
  'set.tb.emptyDesc': 'Import ticket fields to start building this form.',
  'set.tb.deleting': 'Deleting…',
  'set.tp.loadError': 'Unable to load the form preview.',
  'set.tp.preview': 'Preview',
  'set.tp.customerPreview': 'Customer-facing preview',
  'set.tp.backToBuilder': 'Back to builder',
  'set.tp.modeTitle': 'Preview mode',
  'set.tp.modeDesc': 'This is a non-submitting preview. All enabled fields are shown in the saved form order.',
  'set.tp.emptyTitle': 'No fields are enabled yet',
  'set.tp.emptyDesc': 'Enable fields in the form builder to see them in this preview.',

  'por.error.generic': 'Unable to complete the request.',
  'por.error.requestNotFound': 'Request not found.',
  'por.error.formUnavailable': 'The request form is not available.',
  'por.error.articleNotFound': 'Article not found.',
  'por.error.selectRating': 'Please select a rating from 1 to 5.',
  'por.tab.all': 'All',
  'por.list.title': 'My support requests',
  'por.list.description': 'Track your requests and reply to the support team.',
  'por.list.newRequest': 'New request',
  'por.list.knowledgeBase': 'Knowledge base',
  'por.list.filterByStatus': 'Filter requests by status',
  'por.list.searchPlaceholder': 'Search by subject…',
  'por.list.count': '{count} requests',
  'por.list.countOne': '{count} request',
  'por.list.emptyFilteredTitle': 'No requests match this view',
  'por.list.emptyTitle': 'No requests yet',
  'por.list.emptyFilteredDescription': 'Try the All tab or a different search term.',
  'por.list.emptyDescription': 'Submit a request and the support team will pick it up.',
  'por.list.submitFirst': 'Submit your first request',
  'por.col.request': 'Request',
  'por.col.subject': 'Subject',
  'por.col.status': 'Status',
  'por.col.priority': 'Priority',
  'por.col.created': 'Created',
  'por.detail.myRequests': 'My requests',
  'por.detail.reopen': 'Reopen this request',
  'por.detail.attachments': 'Attachments',
  'por.detail.download': 'Download',
  'por.detail.conversation': 'Conversation',
  'por.detail.noReplies': 'No replies yet',
  'por.detail.noRepliesHint': 'Add a reply below and the support team will pick it up.',
  'por.detail.reply': 'Reply',
  'por.detail.replyPlaceholder': 'Write a reply',
  'por.detail.sending': 'Sending…',
  'por.detail.sendReply': 'Send reply',
  'por.file.sizeKb': '{size} KB',
  'por.file.remove': 'Remove {name}',
  'por.submit.newRequest': 'New request',
  'por.submit.defaultTitle': 'Submit a support request',
  'por.submit.intro': 'Complete the fields below and submit your request.',
  'por.submit.subjectRequired': 'Subject is required',
  'por.submit.descriptionRequired': 'Description is required',
  'por.submit.attachments': 'Attachments',
  'por.submit.submitting': 'Submitting…',
  'por.submit.submit': 'Submit request',
  'por.kb.portal': 'Portal',
  'por.kb.title': 'Knowledge base',
  'por.kb.description': 'Find answers before submitting a request.',
  'por.kb.crumbRoot': 'KB',
  'por.kb.searchResults': 'Search results',
  'por.kb.searchPlaceholder': 'Search articles',
  'por.kb.emptyTitle': 'No articles published yet',
  'por.kb.emptyDescription': 'Submit a request and the support team will help you directly.',
  'por.kb.noFolders': 'No folders',
  'por.kb.articles': '{count} articles',
  'por.kb.articlesOne': '{count} article',
  'por.kb.noMatch': 'No articles match “{query}”',
  'por.kb.folderEmpty': 'No articles in this folder yet',
  'por.kb.noMatchHint': 'Try a shorter search term, or submit a request instead.',
  'por.kb.folderEmptyHint': 'Browse another folder, or submit a request instead.',
  'por.kb.submitRequest': 'Submit a request',
  'por.kb.views': '{count} views',
  'por.kb.thanks': 'Thanks for your feedback!',
  'por.kb.helpful': 'Was this helpful?',
  'por.kb.yes': 'Yes',
  'por.kb.no': 'No',
  'por.csat.thanksTitle': 'Thank you for your feedback',
  'por.csat.thanksBody': 'Your response has been recorded.',
  'por.csat.title': 'How did we do?',
  'por.csat.request': 'Request #{number}: {subject}',
  'por.csat.rating': 'Rating',
  'por.csat.stars': '{count} stars',
  'por.csat.comment': 'Comment',
  'por.csat.submit': 'Submit feedback',
  'agents.tempPassword.title': 'Temporary password',
  'agents.tempPassword.help': 'Set a temporary password for this agent. They will be asked to choose a new password the next time they sign in. At least 12 characters, with an uppercase letter, a lowercase letter, a number and a symbol.',
  'agents.tempPassword.button': 'Set temporary password',
  'agents.tempPassword.saving': 'Setting…',
  'agents.tempPassword.error': 'Unable to set the temporary password.',
  'ui.showPassword': 'Show password',
  'ui.hidePassword': 'Hide password',
  'agents.tempPassword.successEmailed': 'Temporary password set and emailed to the agent.',
  'agents.tempPassword.successNotEmailed': 'Temporary password set, but the email could not be sent. Share the password with the agent through a secure channel.',
} as const;

export default en;
